import {Link, useLocation} from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button.jsx";
import {
    actionAppearance,
    bulkDeleteModal,
    checkAll,
    deleteModalSingle,
    showModal,
    formatPhone,
    formFail,
    handleSubmitActions,
    paginateData,
    sortFunc,
    swapModal,
    formCheck,
    formCheckWithElement,
    formSuccess,
    formClear,
    closeModal,
    hideModal,
    iAmHigherAuthority,
    isBannerPresent,
    versionSort,
    getToday,
    formatDateIso,
    getUTCTimestamp, arrayComparison, headerFilterFunc, searchFunc
} from "../libs.jsx";
import ApiRequester from "./ApiRequester.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import {CSVLink} from "react-csv";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import SingleDeleteModal from "./component-assets/SingleDeleteModal.jsx";
import BulkDeleteModal from "./component-assets/BulkDeleteModal.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import {toast, ToastContainer} from "react-toastify";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import Navigation from "./Navigation.jsx";
import SearchableDropdown from "./component-assets/SearchableDropdown.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";
import {Modal} from "bootstrap";

const Residents = (props) => {
    let dData, bData, resHeaderData, resHeaderData2, groupHeaderData, csvHeaders, csvGroupHeaders, groupHeaderData2, deviceHeaders;

    const useLocationData = useLocation();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    const [resLinkClose, setResLinkClose] = useState("cancelEditGroupBtn");

    resHeaderData = [
        {label: "First Name", key: "resident_first_name", align: "left", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Last Name", key: "resident_last_name", align: "left", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Nickname", key: "resident_nickname", align: "left",  filtered: true},
        {label: "Area", key: "area_name", align: "left", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Area Type", key: "area_type_name", align: "center",  filtered: true},
        {label: "Groups", key: "resident_group_name", align: "left", filtered: true, type: "ellipsis"},
        {label: "Phone", key: "resident_phone", align: "center", filtered: true, type: "tel"},
        {label: "Email", key: "resident_email", align: "left",  filtered: true},
        {label: "Care Level", key: "ehr_level_of_care", align: "center", filtered: true},
        {label: "Devices", key: "devices", align: "center", filtered: true, filterKey: "device_name",
            link: {enabled: true, type: "conditional-obj", conditionKey: "manufacture_id", displayKey: "device_name",
                condition: {"1": {linkto: "/profiles/inovonics", linkkey: "device_id", displayKey: "device_name"},
                            "4": {linkto: "/profiles/palcare", linkkey: "device_id", displayKey: "device_name"}}}},
        {label: "Status", key: "is_active", align: "center", type: "bool", f: "Moved Out", t: "Active"}
    ];

    resHeaderData2 = [
        {label: "Name", key: "resident_name", align: "left", filtered: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id",
                inmodal: true, modalKey: resLinkClose}},
        {label: "Area", key: "area_name", align: "center", filtered: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id",
                inmodal: true, modalKey: resLinkClose}},
        {label: "Area Type", key: "area_type_description", align: "center", filtered: false}
    ];

    groupHeaderData = [
        {label: "Group", key: "resident_group_name", align: "center", filtered: true},
        {label: "Description", key: "resident_description", align: "left", filtered: true},
        {label: "Residents", key: "resident_name", align: "left", filtered: true, type: "ellipsis"},
    ];

    groupHeaderData2 = [
        {label: "Group", key: "resident_group_name", align: "left"},
        {label: "Description", key: "resident_description", align: "left"},
    ];

    deviceHeaders = [
        {label: "Name", key: "device_name", align: "left", filtered: true,
            link: {enabled: true, type: "conditional", conditionKey: "manufacture_id",
                condition: {"1": {linkto: "/profiles/inovonics", linkkey: "device_id"},
                            "4": {linkto: "/profiles/palcare", linkkey: "device_id"}}}},
        {label: "Description", key: "descriptions", align: "left", filtered: true},
        {label: "Model", key: "inovonics_model_name", align: "center", filtered: true},
        {label: "Serial Number", key: "manufacture_uuid", align: "center", filtered: true},
        {label: "Resident", key: "resident_name", align: "left", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Area", key: "area_name", align: "left", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Registered", key: "is_active", align: "center",  filtered: true, type: "bool", t: "Yes", f: "No"}
    ];

    csvHeaders = [
        {label: "First Name", key: "resident_first_name"},
        {label: "Last Name", key: "resident_last_name"},
        {label: "Nickname", key: "resident_nickname"},
        {label: "Area", key: "area_name"},
        {label: "Area Type", key: "area_type_description"},
        {label: "Groups", key: "resident_group_name"},
        {label: "Phone", key: "resident_phone"},
        {label: "Email", key: "resident_email"},
        {label: "Care Level", key: "ehr_level_of_care"},
        {label: "Device", key: "devices"},
        {label: "Status", key: "status"}
    ];

    csvGroupHeaders = [
        {label: "Group", key: "resident_group_name"},
        {label: "Description", key: "resident_description"},
        {label: "Residents", key: "resident_name"}
    ];

    if (iAmHigherAuthority(99, dData?.role_weight)){
        csvHeaders.splice(0, 0, {label: "Resident ID", key: "resident_id"});
    }

    if (iAmHigherAuthority(99, dData?.role_weight)){
        csvGroupHeaders.splice(0, 0, {label: "Group ID", key: "resident_group_id"});
    }

    if (dData.checkin){
        resHeaderData.splice(-1, 0, {label: "Last Check-in", key: "check_in_time", align: "center", type: "datetime"});
        csvHeaders.splice(-1, 0, {label: "Last Check-in", key: "check_in_time"});
    }

    // Permission Variables
    const [addRights, setAddRights] = useState((!dData.campusData[dData.acnt.toString()]?.ehr_active && iAmHigherAuthority(10, dData.role_weight)) || iAmHigherAuthority(80, dData.role_weight));
    const [groupEditRights, setGroupEditRights] = useState(iAmHigherAuthority(10, dData?.role_weight));
    const [devEditRights, setDevEditRights] = useState(iAmHigherAuthority(10, dData?.role_weight));
    const [editRights, setEditRights] = useState((!dData.campusData[dData.acnt.toString()]?.ehr_active && iAmHigherAuthority(10, dData.role_weight)) || iAmHigherAuthority(80, dData.role_weight));
    const [deleteRights, setDeleteRights] = useState((!dData.campusData[dData.acnt.toString()]?.ehr_active && iAmHigherAuthority(10, dData.role_weight)) || iAmHigherAuthority(80, dData.role_weight));
    const [areaLoaded, setAreaLoaded] = useState(false);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [read, setRead] = useState(true);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    const [tabItem, setTabItem] = useState("init");
    const [count, setCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [stateData, setStateData] = useState(useLocationData.state);
    const [search, setSearch] = useState(""); // Main Table Search Const
    const [search2, setSearch2] = useState("") // Modal Table Search Const
    const [showChecked, setShowChecked] = useState(false);

    // Resident Tab Section
    const [resOrigin, setResOrigin] = useState([]); // All Res data
    const [resTransOrigin, setResTransOrigin] = useState([]); // Main res table data filtered
    const [resActive, setResActive] = useState([]);
    const [resTableRows, setResTableRows] = useState([]);
    const [resHeaderFilters, setResHeaderFilters] = useState([]);
    const [showInactive, setShowInactive] = useState(false);
    const [selectReq, setSelectReq] = useState(false);
    const [resDataCnt, setResDataCnt] = useState(0);
    const [resIdList, setResIdList] = useState([]);
    const [editLocationId, setEditLocationId] = useState(0);
    const [addLocationId, setAddLocationId] = useState(undefined);
    const [editLocationName, setEditLocationName] = useState("");
    const [resGroupIdList2, setResGroupIdList2] = useState([]);
    const [oldResGroupIdList2, setOldResGroupIdList2] = useState([]);
    const [groupTableRows2, setGroupTableRows2] = useState([]);
    const [sorter, setSorter] = useState({
        sortColumn: "resident_last_name",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });

    // Group Tab Section
    const [groupOrigin, setGroupOrigin] = useState([]);
    const [groupActive, setGroupActive] = useState([]);
    const [resGroupIdList, setResGroupIdList] = useState([]);
    const [groupHeaderFilters, setGroupHeaderFilters] = useState([]);
    const [resTableRows2, setResTableRows2] = useState([])
    const [resTransOrigin2, setResTransOrigin2] = useState([]); // Modal resident data
    const [oldResGroupIdList, setOldResGroupIdList] = useState([]);
    const [resIdList2, setResIdList2] = useState([]);
    const [oldResIdList2, setOldResIdList2] = useState([]);
    const [groupDataCnt, setGroupDataCnt] = useState(0);
    const [groupTableRows, setGroupTableRows] = useState([]);
    const [sorter2, setSorter2] = useState({
        sortColumn: "resident_group_name",
        sortOrder: "asc"
    });
    const [ppRules2, setPRules2] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });

    // Page Load Variables
    const [resDataLoaded, setResDataLoaded] = useState(false);
    const [resLoaded, setResLoaded] = useState(false);
    const [groupDataLoaded, setGroupDataLoaded] = useState(false);
    const [groupsLoaded, setGroupsLoaded] = useState(false);
    const [catLoaded, setCatLoaded] = useState(false);
    const [deviceDataLoaded, setDeviceDataLoaded] = useState(false);
    const [devicesLoaded, setDevicesLoaded] = useState(false);

    // Device Section
    const [deviceData, setDeviceData] = useState([]);
    const [assignedRes, setAssignedRes] = useState("");
    const [editDeviceList, setEditDeviceList] = useState([]);
    const [storedIndex, setStoredIndex] = useState(0);
    const [manufactureData, setManufactureData] = useState([]);
    const [manufactureOptions, setManufactureOptions] = useState([]);
    const [manufactureId, setManufactureId] = useState(0);
    const [accutechDeviceData, setAccutechDeviceData] = useState([]);
    const [palcareDeviceData, setPalcareDeviceData] = useState([]);
    // Device Section v2
    const [resRegData, setResRegData] = useState([]);
    const [assignedDevices, setAssignedDevices] = useState([]);
    const [assignedFilters, setAssignedFilters] = useState([]);
    const [assignedActive, setAssignedActive] = useState([]);
    const [assignedTableRows, setAssignedTableRows] = useState([]);
    const [unassignedDevices, setUnassignedDevices] = useState([]);
    const [unassignedFilters, setUnassignedFilters] = useState([]);
    const [unassignedActive, setUnassignedActive] = useState([]);
    const [unassignedTableRows, setUnassignedTableRows] = useState([]);
    const [deviceTabItem, setDeviceTabItem] = useState("assign");
    const [assignTabItem, setAssignTabItem] = useState("assigned");
    const [deviceSearch, setDeviceSearch] = useState("");
    const [assignedSorter, setAssignedSorter] = useState({
        sortColumn: "descriptions",
        sortOrder: "asc"
    });
    const [unassignedSorter, setUnassignedSorter] = useState({
        sortColumn: "descriptions",
        sortOrder: "asc"
    });
    // Learn In Variables
    const [listening, setListening] = useState(false); // Flag indicating listening started, stopped
    const [listenEnabled, setListenEnabled] = useState(false); // Flag if listen feature ready or not
    const [listenCount, setListenCount] = useState(60);  // Counter for fetching and toggle listen off
    const [listenData, setListenData] = useState([]);  // Data response of devices heard
    const [listenList, setListenList] = useState([]); // Drop down options for heard devices serial numbers
    const [deviceCatData, setDeviceCatData] = useState([]);  // Device category data used for drop down in learn in
    const [deviceCatOptions, setDeviceCatOptions] = useState([]);  // Device category drop down options for learn in
    const [deviceTypeData, setDeviceTypeData] = useState([]); // Data used for device type drop down in learn in
    const [deviceTypeOptions, setDeviceTypeOptions] = useState([]); // Device type drop down options for learn in
    const [deviceCatId, setDeviceCatId] = useState(0);  // Device Category set in learn in
    const [deviceTypeId, setDeviceTypeId] = useState([]);  // Device Type set in learn in
    const [modelId, setModelId] = useState(0);  // Model selected in list
    const [modelOptions, setModelOptions] = useState([]);
    const [msgClass, setMsgClass] = useState(0);
    const [productCode, setProductCode] = useState(0);
    const [marketId, setMarketId] = useState(0);
    const [allProductCodes, setAllProductCodes] = useState([]);
    const [showDeviceList, setShowDeviceList] = useState(false); // Toggles showing drop down serial or not and required validation
    const [listenDevice, setListenDevice] = useState("");
    const [deviceTypeName, setDeviceTypeName] = useState("");
    const [listenPCode, setListenPCode] = useState(0);
    const [useOptions, setUseOptions] = useState([]);
    const [useId, setUseId] = useState(0);
    const [showAlarmBehaviors, setShowAlarmBehaviors] = useState(false);
    const [deviceImg, setDeviceImg] = useState("");
    // Group Category Variables
    const [groupCategoryData, setGroupCategoryData] = useState([]);
    const [groupCatDd, setGroupCatDd] = useState([]);
    const [groupCatSorter, setGroupCatSorter] = useState({
        sortColumn: "resident_group_category_name",
        sortOrder: "asc"
    })
    // Location Section Variables
    const [areaData, setAreaData] = useState([]);
    // const [locationOptions, setLocationOptions] = useState("");
    // const [locationSorter, setLocationSorter] = useState({
    //     sortColumn: "area_name",
    //     sortOrder: "asc"
    // });
    // Resident Mobile Variables
    const [mobileAppDisplay, setMobileAppDisplay] = useState(<></>);
    const [onLoad, setOnLoad] = useState(true);
    const [isMobileActive, setIsMobileActive] = useState(dData.resMobile);
    // Other Enact Once Variables
    const [serialPattern, setSerialPattern] = useState("^[0-9]+$");
    const [csvLink, setLink] = useState({
        filename: "Residents.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "sp_dev_getallresidentsanddevicesbycampusid", reqType: "stored"}).then(data => {
                setResOrigin(data);
                setResDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                payload: {campus_id: campusId, category_filter: "", entity_type_filter: "",
                                            entity_filter: ""},
                                procedure: "sp_dev_getresidentgroupandresidentbycampusid", reqType: "stored"}).then(data => {
                setGroupOrigin(data ? data : []);
                setGroupDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                Tbl: "att_resident_group_category", "read-only": true,
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setGroupCategoryData(data ? data : []);
                setCatLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "sp_dev_getareasbycampusid", reqType: "stored"}).then(data => {
                setAreaData(data);
                setAreaLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: "",
                                device_category_filter: "1,2,3,6,7,8,9,10,11,12,15,16,17", campus_id: campusId}, "read-only": read,
                                procedure: "sp_dev_getInovonicsDevices", reqType: "stored"}).then(data => {
                setDeviceData(data);
                setDeviceDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_resident_groups",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": true}).then(data => {
                setGroupOrigin(data);
                setGroupDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getresidentdevicecategories", reqType: "stored", "read-only": true}).then(data => {
                setDeviceCatData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getinovonicsdevicetypes", reqType: "stored", "read-only": true}).then(data => {
                setDeviceTypeData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getaccutechresidentdevices", reqType: "stored", "read-only": true}).then(data => {
                setAccutechDeviceData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getpalcareresidentdevices", reqType: "stored", "read-only": true}).then(data => {
                setPalcareDeviceData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_manufactures",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setManufactureData(data);
            });
            setCount(count => 1200);
            setRead(true);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        setResTransOrigin(resOrigin.filter((item) => {return (showInactive || (!showInactive && item?.is_active))}));
        setResTransOrigin2(resOrigin.filter((item) => {return item?.is_active}))
    }, [resOrigin, showInactive]);

    useEffect(() => {
        if (tabItem === "residents"){
            const exportData = resTransOrigin.map(row => ({
                ...row,
                status: row.is_active ? "Active" : "Moved Out",
                devices: Array.isArray(row.devices)
                    ? row.devices.map(device => `${device.device_name} (${device.manufacture_uuid})`).join(" | ")
                    : row.devices
            }));
            setLink(prevState => {
                return {...prevState,
                    filename: "Residents.csv",
                    headers: csvHeaders,
                    data: exportData}
            });
        }else{
            setLink(prevState => {
                return {...prevState,
                    filename: "Resident_Groups.csv",
                    headers: csvGroupHeaders,
                    data: groupOrigin}
            });
        }
    }, [resTransOrigin, groupOrigin, tabItem]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                        class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [csvLink]);

    useEffect(() => {
        if (stateData && stateData?.message){
            if (stateData.message?.error){
                toast.error(stateData.message.error);
            }else if (stateData.message?.success){
                toast.success(stateData.message.success);
            }
        }
    }, [stateData]);

    useEffect(() => {
        if (resLoaded){
            if (tabItem === "init") {
                setTabItem("residents");
            }
        }
    }, [resLoaded]);

    useEffect(() => {
        if ([resDataLoaded, areaLoaded].every((item) => item === true)){
            setResLoaded(true);
        }
    }, [resDataLoaded, areaLoaded]);

    useEffect(() => {
        if ([groupDataLoaded, catLoaded].every((item) => item === true)){
            setGroupsLoaded(true);
        }
    }, [groupDataLoaded, catLoaded]);

    useEffect(() => {
        if ([deviceDataLoaded].every((item) => item === true)){
            setDevicesLoaded(true);
        }
    }, [deviceDataLoaded]);

    useEffect(() => {
        if (groupCategoryData.length > 0){
            let tmpOptions = [];
            groupCategoryData.sort((a, b) => sortFunc(a, b, groupCatSorter.sortColumn, groupCatSorter.sortOrder));
            for (let i=0; i<groupCategoryData.length; i++){
                tmpOptions.push(
                    <option key={"area-type-option-"+groupCategoryData[i].resident_group_category_id.toString()}
                            value={groupCategoryData[i].resident_group_category_id}>{groupCategoryData[i].resident_group_category_name}</option>
                );
            }
            setGroupCatDd(() => tmpOptions);
        }
    }, [groupCategoryData]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(resTransOrigin, resHeaderFilters, resHeaderData);

        searchKeys = ["resident_first_name", "resident_last_name", "resident_phone", "area_name", "resident_email",
            "resident_nickname", "area_type_name", "area_type_description", ["resident_first_name", "resident_last_name"]];
        tmpData = searchFunc(search, filteredData, searchKeys)

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setResActive(tmpData);
    }, [search, resTransOrigin, resHeaderFilters]);

    useEffect(() => {
        let pRules = paginateData(resActive, page, perPage);
        setPRules(pRules);
        if (resActive.length > 0) {
            resActive.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setResTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={resActive} checkbox={deleteRights}
                                writeAccess={editRights || groupEditRights} unk={"a-"} addlEditKey={"is_active"} addlEditCheck={true}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteResBtn", "trueDeleteBtn"], "uCheckRes")}
                                tableHeaders={resHeaderData} editModal={editResModal} parentComponent={"Residents"} dData={dData}
                                modal={(editRights || groupEditRights) && (areaLoaded && groupsLoaded)} checkboxlist={resIdList}
                                setCheckboxId={(value) => {setResIdList(value)}} checkboxId={"uCheckRes"}
                                checkidkey={"resident_id"} />);
    }, [resActive, sorter, page, perPage, resIdList, tabItem]);

    useEffect(() => {
        let tmpData, searchKeys;
        // Handles Area Group Edit Area Table

        searchKeys = ["resident_name", "area_name", "area_type_name", "area_type_description"];
        tmpData = searchFunc(search2, resTransOrigin2, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return resIdList2.includes(item.resident_id.toString())})
        }
        setResDataCnt(tmpData.length)
        tmpData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        setResTableRows2(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={deleteRights}
                                writeAccess={editRights || groupEditRights} unk={"b-"} addlEditKey={"is_active"} addlEditCheck={false}
                                actionAppearance={() => {}} modal={false} checkboxlist={resIdList2}
                                tableHeaders={resHeaderData2} parentComponent={"Residents"} dData={dData}
                                setCheckboxId={(value) => {setResIdList2(value)}} checkboxId={"uCheckRes2_"}
                                checkidkey={"resident_id"} />);
    }, [resTransOrigin2, sorter, resIdList2, tabItem, showChecked]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(groupOrigin, groupHeaderFilters, groupHeaderData);

        searchKeys = ["resident_group_name", "resident_description", "resident_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page2, perPage);
        if (search && page2 > pRules.pageMax){
            setPage2(pRules.pageMax);
        }else if (!search){
            setPage2(storePage);
        }
        setPRules2(pRules);
        setGroupActive(tmpData);
    }, [search, groupOrigin, groupHeaderFilters, tabItem]);

    useEffect(() => {
        let pRules = paginateData(groupActive, page2, perPage);
        setPRules2(pRules);
        if (groupActive.length > 0) {
            groupActive.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        }
        setGroupTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={groupActive} checkbox={groupEditRights} writeAccess={groupEditRights}
                                     actionAppearance={() => {actionAppearance(pRules.start, pRules.end, ["deleteGroupBtn"], "uCheckGroup")}}
                                     tableHeaders={groupHeaderData} checkboxId={"uCheckGroup"}
                                     parentComponent={"Residents"} dData={dData} checkboxlist={resGroupIdList}
                                     modal={groupEditRights} editModal={editGroupModal} unk={"c-"}
                                     setCheckboxId={(value) => {setResGroupIdList(value)}} checkidkey={"resident_group_id"} />);
    }, [groupActive, resGroupIdList, sorter2, search, page2, perPage, tabItem]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["resident_group_name", "resident_description", "resident_name"];
        tmpData = searchFunc(search2, groupOrigin, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return resGroupIdList2.includes(item.resident_group_id.toString())})
        }
        setGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        setGroupTableRows2(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={groupEditRights} writeAccess={groupEditRights}
                                     actionAppearance={() => {}} tableHeaders={groupHeaderData2} checkboxId={"uCheckGroup2_"}
                                     parentComponent={"Residents"} dData={dData} checkboxlist={resGroupIdList2}
                                     modal={false} editModal={() => {}} unk={"d-"}
                                     setCheckboxId={(value) => {setResGroupIdList2(value)}} checkidkey={"resident_group_id"} />);
    }, [groupOrigin, resGroupIdList2, sorter2, search2, showChecked]);

    useEffect(() => {
        let i, tmp = [];
        manufactureData.sort((a, b) => sortFunc(a, b, "manufacture_name", "asc"));
        for (i = 0; i < manufactureData.length; i++){
            if (manufactureData[i].devices_supported) {
                tmp.push(
                    <option key={"manufacture-option-"+manufactureData[i]?.manufacture_id.toString()}
                            value={manufactureData[i]?.manufacture_id}>{manufactureData[i]?.manufacture_name}
                    </option>
                );
            }
        }
        setManufactureOptions(() => tmp);
    }, [manufactureData]);

    useEffect(() => {
        let tmpOptions = [];
        if (manufactureId.toString() === "1"){
            for (let i=0; i < deviceCatData.length; i++){
                tmpOptions.push(
                    <option key={`device-category-option-${deviceCatData[i].device_category_id}`}
                            value={deviceCatData[i].device_category_id}>{deviceCatData[i].device_category_short_name}
                    </option>
                );
            }
        }else if (manufactureId.toString() === "6"){
            tmpOptions.push(
                <option key={"device-category-option-1"}
                        value={1}>{"RF Tags"}
                </option>
            );
        }else if (manufactureId.toString() === "4"){
            tmpOptions.push(
                <option key={"device-category-option-1"}
                        value={2}>{"Pendants"}
                </option>
            );
        }
        setDeviceCatOptions(() => tmpOptions);
    }, [deviceCatData, manufactureId]);

    useEffect(() => {
        let i, tmp = [];
        if (manufactureId.toString() === "1"){
            document.getElementById("listen-container-main").classList.remove("d-none");
            deviceTypeData.sort((a, b) => sortFunc(a, b, "device_type_name", "asc"));
            for (i = 0; i < deviceTypeData.length; i++){
                if ((deviceTypeData[i]?.device_category_id.toString() === deviceCatId.toString()) &&
                    (iAmHigherAuthority(80, dData.role_weight) || !deviceTypeData[i]?.is_third_party)){
                    tmp.push(
                        <option key={"device-use-option-"+deviceTypeData[i]?.inovonics_type_id.toString()}
                                value={deviceTypeData[i]?.inovonics_type_id}>{deviceTypeData[i]?.device_type_name}
                        </option>
                    );
                }
            }
        }else if (manufactureId.toString() === "6"){
            document.getElementById("listen-container-main").classList.add("d-none");
            accutechDeviceData.sort((a, b) => sortFunc(a, b, "description", "asc"));
            for (i = 0; i < accutechDeviceData.length; i++){
                if (deviceCatId === 1){
                    tmp.push(
                        <option key={"device-use-option-"+accutechDeviceData[i]?.accutech_device_id.toString()}
                                value={accutechDeviceData[i]?.accutech_device_id}>{accutechDeviceData[i]?.description}
                        </option>
                    );
                }
            }
        }else if (manufactureId.toString() === "4"){
            document.getElementById("listen-container-main").classList.add("d-none");
            palcareDeviceData.sort((a, b) => sortFunc(a, b, "device_type_name", "asc"));
            for (i = 0; i < palcareDeviceData.length; i++){
                if (palcareDeviceData[i]?.device_category_id.toString() === deviceCatId.toString()){
                    tmp.push(
                        <option key={`device-use-option-${palcareDeviceData[i]?.device_type_id}`}
                                value={palcareDeviceData[i]?.device_type_id}>{palcareDeviceData[i]?.device_type_name}
                        </option>
                    );
                }
            }
        }else{
            document.getElementById("listen-container-main").classList.add("d-none");
        }
        setDeviceTypeOptions(() => tmp);
    }, [deviceTypeData, deviceCatId, accutechDeviceData, manufactureId, palcareDeviceData]);

    // useEffect(() => {
    //
    // }, [deviceTypeData]);

    useEffect(() => {
        let tmp = [], models = [], tmp2 = [], uses = [], tmp3 = [], imgstr = "";
        if (manufactureId.toString() === "1"){
            for (let i=0; i < deviceTypeData.length; i++){
                if (deviceTypeData[i]?.inovonics_type_id === deviceTypeId){
                    models = deviceTypeData[i]?.models ? deviceTypeData[i].models : [];
                    uses = deviceTypeData[i]?.uses ? deviceTypeData[i].uses : [];
                    imgstr = deviceTypeData[i]?.image_url ? deviceTypeData[i].image_url : "";
                    break;
                }
            }
            for (let i2=0; i2 < models.length; i2++){
                if (i2 === 0){
                    setModelId(models[i2].model_id);
                    setMsgClass(models[i2].message_class);
                    setProductCode(models[i2].product_type_id);
                    setMarketId(models[i2].market_id);
                }
                tmp2.push(models[i2].product_type_id);
                tmp.push(
                    <option key={`device-model-option-${i2}`}
                            value={models[i2]?.model_id}>{models[i2]?.model_name}
                    </option>
                );
            }
            for (let i3=0; i3 < uses.length; i3++){
                if (i3 === 0){
                    setUseId(uses[i3].inovonics_device_use_id);
                    setShowAlarmBehaviors(uses[i3].option_number !== 0);
                }
                if (uses[i3].option_number !== 0){
                    tmp3.push(
                        <div className={"form-check form-switch mt-1"} id={`use-option-${uses[i3].option_number}-container`}>
                            <input className={"form-check-input"} id={`use-option-${uses[i3].option_number}`} type={"radio"}
                                   name={"alarmBehavior"} value={uses[i3].inovonics_device_use_id} defaultChecked={i3 === 0}
                                   onChange={(e) => {setUseId(parseInt(e.target.value))}} />
                            <label className={"form-check-label me-4 mt-1 text-dark"}
                                   htmlFor={`use-option-${uses[i3].option_number}`} id={`use-option-label-${uses[i3].option_number}`}>
                                {uses[i3].option_text}
                            </label>
                        </div>
                    );
                }
            }
        }else if (manufactureId.toString() === "6"){
            setShowAlarmBehaviors(false);
            setModelId(deviceTypeId);
            setUseId(0);
            for (let i=0; i < accutechDeviceData.length; i++){
                if (accutechDeviceData[i]?.accutech_device_id === deviceTypeId){
                    tmp.push(
                        <option key={`device-model-option-${i}`}
                                value={accutechDeviceData[i]?.accutech_device_id}>
                            {accutechDeviceData[i]?.accutech_model_id}
                        </option>
                    );
                }
            }
        }else if (manufactureId.toString() === "4"){
            for (let i=0; i < palcareDeviceData.length; i++){
                if (palcareDeviceData[i]?.device_type_id === deviceTypeId){
                    models = palcareDeviceData[i]?.models ? palcareDeviceData[i].models : [];
                    break;
                }
            }
            for (let i2=0; i2 < models.length; i2++){
                if (i2 === 0){
                    setModelId(models[i2].model_id);
                }
                tmp.push(
                    <option key={`device-model-option-${i2}`}
                            value={models[i2]?.model_id}>{models[i2]?.model_name}
                    </option>
                );
            }
        }
        setAllProductCodes(tmp2);
        setModelOptions(() => tmp);
        setUseOptions(() => tmp3);
        setDeviceImg(imgstr);
    }, [deviceTypeData, deviceTypeId, accutechDeviceData, palcareDeviceData]);

    useEffect(() => {
        let tmpA = [], tmpU = []
        if (devicesLoaded){
            for (let i=0; i<deviceData.length; i++){
                if (!deviceData[i].is_area_device){
                    if ([null, undefined, 0].includes(deviceData[i].resident_id)){
                        tmpU.push(deviceData[i])
                    }else{
                        tmpA.push(deviceData[i])
                    }
                }
            }
            setAssignedDevices(tmpA);
            setUnassignedDevices(tmpU);
        }
    }, [deviceData, devicesLoaded]);

    useEffect(() => {
        let tmpData, searchKeys

        let filteredData = headerFilterFunc(assignedDevices, assignedFilters, deviceHeaders);

        searchKeys = ["device_name", "descriptions", "manufacture_uuid", "inovonics_model_name", "area_name", "resident_name"];
        tmpData = searchFunc(deviceSearch, filteredData, searchKeys)

        setAssignedActive(tmpData);
    }, [assignedDevices, deviceSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        let filteredData = headerFilterFunc(unassignedDevices, unassignedFilters, deviceHeaders);

        searchKeys = ["device_name", "descriptions", "manufacture_uuid", "inovonics_model_name",
            "area_name", "resident_name"];
        tmpData = searchFunc(deviceSearch, filteredData, searchKeys);

        setUnassignedActive(tmpData);
    }, [unassignedDevices, deviceSearch]);

    useEffect(() => {
        setAssignedTableRows(<TableBody start={0} end={assignedActive.length} tableData={assignedActive} writeAccess={true}
                                        unk={"da-"} actionAppearance={() => {}} tableHeaders={deviceHeaders}
                                        editModal={() => {}} parentComponent={"Residents"} dData={dData}
                                        checkboxlist={[]} setCheckboxId={() => {}} checkidkey={"device_id"} />);
    }, [assignedActive]);

    useEffect(() => {
        setUnassignedTableRows(<TableBody start={0} end={unassignedActive.length} tableData={unassignedActive} writeAccess={true}
                                          unk={"du-"} actionAppearance={() => {}} tableHeaders={deviceHeaders}
                                          editModal={() => {}} parentComponent={"Residents"} dData={dData}
                                          checkboxlist={[]} setCheckboxId={() => {}} checkidkey={"device_id"} />);
    }, [unassignedActive]);

    useEffect(() => {
        let models = [];
        if (manufactureId.toString() === "1"){
            for (let i=0; i < deviceTypeData.length; i++){
                if (deviceTypeData[i]?.inovonics_type_id === deviceTypeId){
                    models = deviceTypeData[i]?.models ? deviceTypeData[i].models : [];
                    break;
                }
            }
            for (let i2=0; i2 < models.length; i2++){
                if (models[i2].model_id === modelId){
                    setMsgClass(models[i2].message_class);
                    setProductCode(models[i2].product_type_id);
                    setMarketId(models[i2].market_id);
                }
            }
        }
        setListenEnabled(modelId !== 0);
    }, [modelId]);

    useEffect(() => {
        formCheck("editResForm", "editResSubmit");
    }, [editLocationId]);

    useEffect(() => {
        formCheck("addResForm", "addResSubmit");
    }, [addLocationId]);

    useEffect(() => {
        let tmpList = [];
        for (let i=0; i < listenData.length; i++){
            tmpList.push(
                <option key={`listen-${listenData[i]?.trx_id}`} value={[listenData[i]?.trx_id, listenData[i]?.pType]}>
                    {listenData[i]?.name} ({listenData[i]?.trx_id})
                </option>
            );
        }
        setListenList(tmpList);
        if (listenDevice === "" && listenData.length > 0){
            setListenDevice(() => listenData[0]?.trx_id);
            setListenPCode(() => listenData[0]?.pType)
            toast.success("Devices found.");
        }
    }, [listenData]);

    useEffect(() => {
        buildDeviceList(-1);
    }, [resActive]);

    useEffect(() => {
        let interval;
        if (checkListenValid()){
            interval = setInterval(() => {
                setListenCount(listenCount  => listenCount  + 1);
            }, 1000);
            if (listenCount < 60){
                if (listenCount % 4 === 0){
                    ApiRequester({reqEndpoint: "getitems", Table: "LearnIn", PKey: "ClientId",
                        PVal: dData.sessionId, CampusId: campusId}).then(data => {
                            setListenData(data);
                    });
                }
            }
            if (listenCount === 60){
                setListening(false);
                toast.info("Capture timeout, restart capture if device not in list.");
            }
        }
        return () => clearInterval(interval);
    }, [listenCount]);

    useEffect(() => {
        formCheck("pendantForm", "pendantSubmit");
    }, [listening, listenDevice]);

    function checkListenValid(){
        return [listening, manufactureId.toString() === "1", deviceCatId !== 0, deviceTypeId !== 0].every((item) => item === true);
    }

    function editResModal(editIndex){
        let fullname, dataIndex, resId, delBtn, roomphone, groupIdList = [];
        if (editRights || groupEditRights){
            setShowChecked(false);
            dataIndex = parseInt(editIndex);
            setSearch2("");
            setStoredIndex(dataIndex);
            buildDeviceList(dataIndex);
            if (resActive[dataIndex]?.resident_phone){
                roomphone = formatPhone(resActive[dataIndex].resident_phone);
            }else{
                roomphone = "";
            }
            fullname = `${resActive[dataIndex]?.resident_first_name} ${resActive[dataIndex]?.resident_last_name}`;
            document.getElementById("fNameE").value = resActive[dataIndex]?.resident_first_name;
            document.getElementById("lNameE").value = resActive[dataIndex]?.resident_last_name;
            document.getElementById("resUnqIdE").value = resActive[dataIndex]?.resident_id;
            resId = resActive[dataIndex]?.resident_id;
            document.getElementById("emailE").value = resActive[dataIndex]?.resident_email;
            document.getElementById("roomPhE").value = roomphone;
            document.getElementById("campusIdE").value = resActive[dataIndex]?.campus_id;
            document.getElementById("nicknameE").value = resActive[dataIndex]?.resident_nickname ? resActive[dataIndex].resident_nickname : "";
            document.getElementById("ehridE").value = resActive[dataIndex]?.ehr_external_id ? resActive[dataIndex].ehr_external_id : "";
            document.getElementById("uCheckHead6").checked = false;
            setEditLocationName(resActive[dataIndex]?.area_name);
            setEditLocationId(resActive[dataIndex]?.area_id);
            document.getElementById("origLocationIdE").value = resActive[dataIndex]?.area_id;
            document.getElementById("locationIdE").value = resActive[dataIndex]?.area_id;
            for (let i2=0; i2<resActive[dataIndex]?.resident_groups?.length; i2++){
                groupIdList.push(resActive[dataIndex]?.resident_groups[i2]?.resident_group_id.toString());
            }
            setResGroupIdList2(groupIdList);
            setOldResGroupIdList2(groupIdList);
            document.getElementById("uCheckHead6").checked = groupIdList && groupIdList.length === groupOrigin.length;
            delBtn = document.getElementById("deleteSingleResBtn");
            console.log(delBtn)
            if (delBtn !== null){
                delBtn.onclick = () => {
                    setDContent([[resId, ""]]);
                    deleteModalSingle(fullname, fullname, "cancelEditResBtn", "Are you sure you want to move out");
                };
            }
            // if (isMobileActive){
            //     if (resActive[dataIndex]?.cognito_id){
            //         setMobileAppDisplay(() => {return (
            //             <>
            //                 <h5 className={"d-inline-block mb-3"}>Username: </h5><span className={"ms-3"}>{resActive[dataIndex]?.username}</span>
            //                 <Button text={"Password Reset"} type={"button"} class={"btn btn-primary d-block"} id={"passBtn"}
            //                         icon={true} iconClass={"fe fe-lock me-2"} onClick={() => swapModal("cancelEditBtn", "passmodal")} />
            //             </>
            //         )});
            //     }else{
            //         setMobileAppDisplay(() => {return (
            //             <>
            //                 <h5 className={"d-inline-block mb-3"}>App not set up for resident</h5>
            //                 <Button text={"Sign-up Resident"} class={"btn btn-primary d-block"}
            //                         onClick={() => swapModal("cancelEditBtn", "addmobilemodal")} />
            //             </>
            //         )});
            //     }
            // }else{
            //     setMobileAppDisplay(() => {return (<></>)});
            // }
            formCheck("editResForm", "editSubmit");
            showModal("editresmodal");
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function editGroupModal(groupIndex){
        let groupId, groupname, dataIndex, modal, delBtn, rIdList = [];
        if (editRights){
            setShowChecked(false);
            dataIndex = parseInt(groupIndex);
            setSearch2("");
            setStoredIndex(dataIndex);
            setResLinkClose("cancelEditBtn");
            document.getElementById("lastIndex").value = dataIndex;
            groupname = document.getElementById("groupNameE");
            groupId = document.getElementById("groupIdE");
            delBtn = document.getElementById("deleteSingleGroupBtn");
            document.getElementById("categoryE").value = groupActive[dataIndex]?.resident_group_category_id;
            document.getElementById("descriptionE").value = groupActive[dataIndex]?.resident_description;
            document.getElementById("uCheckHead3").checked = false;
            for (let i2=0; i2<groupActive[dataIndex]?.residents?.length; i2++){
                if (!rIdList.includes(groupActive[dataIndex]?.residents[i2]?.resident_id.toString())){
                    rIdList.push(groupActive[dataIndex]?.residents[i2]?.resident_id.toString());
                }
            }
            setResIdList2(rIdList);
            setOldResIdList2(rIdList);
            document.getElementById("uCheckHead3").checked = rIdList && rIdList.length === resOrigin.length;
            groupname.value = groupActive[dataIndex]?.resident_group_name;
            groupId.value = groupActive[dataIndex]?.resident_group_id;
            delBtn.onclick = () => {
                setDContent([[groupId.value, ""]]);
                deleteModalSingle(groupname.value, groupname.value, "cancelEditGroupBtn");
            };
            formCheck("editResForm", "editResSubmit");
            modal = new Modal(document.getElementById("editgroupmodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function removeDevice(deviceIdList){
        let payload = [], oldPayload = [];
        if (devEditRights){
            for (let i=0; i < deviceIdList.length; i++){
                payload.push({device_id: deviceIdList[i], is_active: false, resident_id: null, modified_by: dData.user});
                oldPayload.push({device_id: deviceIdList[i], resident_id: resActive[storedIndex].resident_id});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "device_unassign_resident", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                if (data && data[0] === true){
                    setRead(false);
                    setCount(0);
                    toast.success("Devices have been removed");
                }
                else{
                    toast.error("Failed to remove devices");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function buildDeviceList(dataIndex){
        let tmp = [];
        if (dataIndex === -1){
            dataIndex = storedIndex;
        }
        for (let i=0; i < resActive[dataIndex]?.devices?.length; i++){
            if (resActive[dataIndex]?.devices[i].manufacture_id === 6){
                tmp.push(
                    <tr key={`device-list-item-${i}`}>
                        {devEditRights &&
                            <td>
                                <i className={"fe fe-trash-2 red-hover fs-2 me-3 align-text-bottom"}
                                   onClick={() => removeDevice([resActive[dataIndex]?.devices[i].device_id])}/>
                            </td>
                        }
                        <td className={"fs-4"}>
                            <Link to={`/profiles/wander/${resActive[dataIndex]?.devices[i].device_id}`}
                                  onClick={() => closeModal("cancelEditBtn")}>
                                <span>{resActive[dataIndex]?.devices[i].device_name} </span><span>{resActive[dataIndex]?.devices[i].descriptions}</span><span> ({resActive[dataIndex]?.devices[i].manufacture_uuid})</span>
                            </Link>
                        </td>
                    </tr>
                );
            }else if (resActive[dataIndex]?.devices[i].manufacture_id === 4){
                tmp.push(
                    <tr key={`device-list-item-${i}`}>
                        {devEditRights &&
                            <td>
                                <i className={"fe fe-trash-2 red-hover fs-2 me-3 align-text-bottom"}
                                   onClick={() => removeDevice([resActive[dataIndex]?.devices[i].device_id])}/>
                            </td>
                        }
                        <td className={"fs-4"}>
                            <Link to={`/profiles/palcare/${resActive[dataIndex]?.devices[i].device_id}`}
                                  onClick={() => closeModal("cancelEditBtn")}>
                                <span>{resActive[dataIndex]?.devices[i].device_name} </span><span>{resActive[dataIndex]?.devices[i].descriptions}</span><span> ({resActive[dataIndex]?.devices[i].manufacture_uuid})</span>
                            </Link>
                        </td>
                    </tr>
                );
            }else if (resActive[dataIndex]?.devices[i].manufacture_id === 1){
                tmp.push(
                    <tr key={`device-list-item-${i}`}>
                        {devEditRights &&
                            <td>
                                <i className={"fe fe-trash-2 red-hover fs-2 me-3 align-text-bottom"}
                                   onClick={() => removeDevice([resActive[dataIndex]?.devices[i].device_id])}/>
                            </td>
                        }
                        <td className={"fs-4"}>
                            <Link to={`/profiles/inovonics/${resActive[dataIndex]?.devices[i].device_id}`}
                                  onClick={() => closeModal("cancelEditBtn")}>
                                <span>{resActive[dataIndex]?.devices[i].device_name} </span><span>{resActive[dataIndex]?.devices[i].descriptions}</span><span> ({resActive[dataIndex]?.devices[i].manufacture_uuid})</span>
                            </Link>
                        </td>
                    </tr>
                );
            }else{
                tmp.push(
                    <tr key={`device-list-item-${i}`}>
                        {devEditRights &&
                            <td>
                                <i className={"fe fe-trash-2 red-hover fs-2 me-3 align-text-bottom"}
                                   onClick={() => removeDevice([resActive[dataIndex]?.devices[i].device_id])}/>
                            </td>
                        }
                        <td className={"fs-4"}>
                            <span>{resActive[dataIndex]?.devices[i].device_name} </span><span>{resActive[dataIndex]?.devices[i].descriptions}</span><span> ({resActive[dataIndex]?.devices[i].manufacture_uuid})</span>
                        </td>
                    </tr>
                );
            }
        }
        setEditDeviceList(tmp);
    }

    function filterSubmit() {
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setResIdList([]);
        setPerPage(tmpPerPage);
        dData.perPage = tmpPerPage;
        setPage(1);
        setPage2(1);
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
        formSuccess("Page parameters stored to session.", "filterSubmit",
            "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function formAddResSubmit(){
        // User add form submit function
        let fname, lname, roomPh, payload, email, setmovein, moveindate, hourOfDay, ehrid, nName;
        if (addRights){
            handleSubmitActions("addResSubmit", "loadAddResSubmit");
            fname = document.getElementById("fName").value;
            lname = document.getElementById("lName").value;
            nName = document.getElementById("nickname").value;
            email = document.getElementById("email").value;
            roomPh = document.getElementById("roomPh").value.replaceAll("-", "");
            setmovein = document.getElementById("set-move-in").checked;
            ehrid = document.getElementById("ehrid").value;
            if (setmovein){
                hourOfDay = Math.abs(parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)) + 8;
                if (hourOfDay >= 24){
                    hourOfDay = 23;
                }else if (hourOfDay < 8){
                    hourOfDay = 8;
                }
                moveindate = document.getElementById("moveindate").value.toString() + ` ${hourOfDay}:00:00`;
            }else{
                moveindate = getUTCTimestamp();
            }
            payload = [{campus_id: campusId, resident_first_name: fname, resident_last_name: lname,
                        resident_phone: roomPh, resident_email: email.toLowerCase(), is_area_assigned: true,
                        area_id: addLocationId, resident_group_ids: resGroupIdList2, move_in_date: moveindate,
                        ehr_external_id: ehrid, resident_nickname: nName,
                        offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                        offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data && data[0] === true){
                    setResIdList([]);
                    formSuccess(`${fname} ${lname} has been added`, "addResSubmit",
                        "loadAddResSubmit", "cancelAddResBtn", "addResForm");
                    setRead(false);
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addResSubmit", "loadAddResSubmit");
                }
            });
            handleSubmitActions("loadAddResSubmit", "addResSubmit");
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddMobileSubmit(){
        // User add form submit function
        let fname, lname, roomPh, payload, email, msg, username, passwd, resId;
        if (editRights){
            handleSubmitActions("addMobileSubmit", "loadAddMobileSubmit");
            fname = document.getElementById("fNameE").value;
            lname = document.getElementById("lNameE").value;
            email = document.getElementById("emailE").value;
            roomPh = document.getElementById("roomPhE").value.replaceAll("-", "");
            username = document.getElementById("username").value;
            passwd = document.getElementById("password").value;
            resId = document.getElementById("resUnqIdE").value;
            payload = [{Action: "new", UserEmail: email.toLowerCase(), Username: username, UserPass: passwd, CampusId: campusId,
                        ClientId: dData.sessionId, PhoneNumber: roomPh, RegisterType: "resident", resident_id: parseInt(resId)}];
            ApiRequester({reqEndpoint: "user-manage", Payload: payload}).then(data => {
                if (data[0] === true){
                    setMobileAppDisplay(() => {return (
                        <>
                            <h5 className={"d-inline-block mb-3"}>Username: </h5><span className={"ms-3"}>{username}</span>
                            <Button text={"Password Reset"} type={"button"} class={"btn btn-primary d-block"} id={"passBtn"}
                                        icon={true} iconClass={"fe fe-lock me-2"} onClick={() => swapModal("cancelEditBtn", "passmodal")} />
                        </>
                    )});
                    formSuccess(`${fname} ${lname} has been signed up for the PalCare resident mobile app.`,
                        "addMobileSubmit", "loadAddMobileSubmit", "cancelAddMobileBtn", "addMobileForm");
                    setRead(false);
                    setCount(0);
                }
                else{
                    if (data[1] === "1"){
                        msg = "Username already exists, please change username.";
                    }
                    else if (data[1] === "2"){
                        msg = "Error, user created, failed saving user details. Contact your customer success manager for assistance.";
                    }
                    else if (data[1] === "8"){
                        msg = "Request aborted, missing required data. Contact your customer success manager for assistance.";
                    }
                    else if (data[1] === "9"){
                        msg = "Request aborted, no matching action. Contact your customer success manager for assistance.";
                    }
                    else{
                        msg = "Unknown failure, request not processed.";
                    }
                    formFail(msg, "addMobileSubmit", "loadAddMobileSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditResSubmit(){
        // Location add form submit function
        let fname, lname, resId, email, roomPh, payload, fnameOld, lnameOld, locIdOld, emailOld, roomPhOld, nName,
            oldPayload, oldActive, oldCampus, ehrid, oldEhrId, oldNickname;
        if (editRights || groupEditRights){
            fname = document.getElementById("fNameE").value;
            lname = document.getElementById("lNameE").value;
            email = document.getElementById("emailE").value;
            roomPh = document.getElementById("roomPhE").value.replaceAll("-", "");
            resId = document.getElementById("resUnqIdE").value;
            ehrid = document.getElementById("ehridE").value;
            nName = document.getElementById("nicknameE").value;
            fnameOld = resActive[storedIndex].resident_first_name;
            lnameOld = resActive[storedIndex].resident_last_name;
            locIdOld = resActive[storedIndex].area_id;
            emailOld = resActive[storedIndex].resident_email;
            roomPhOld = resActive[storedIndex].resident_phone;
            oldActive = resActive[storedIndex].is_active;
            oldCampus = resActive[storedIndex].campus_id;
            oldEhrId = resActive[storedIndex].ehr_external_id;
            oldNickname = resActive[storedIndex]?.resident_nickname;
            if (arrayComparison([fname, lname, nName, email, roomPh, ehrid, parseInt(editLocationId)], [fnameOld, lnameOld, oldNickname, emailOld, roomPhOld, oldEhrId, locIdOld])
                || arrayComparison(resGroupIdList2.sort(), oldResGroupIdList2.sort())){
                handleSubmitActions("editResSubmit", "loadEditResSubmit");
                payload = [{resident_id: parseInt(resId), resident_first_name: fname, resident_last_name: lname, is_active: 1,
                        resident_email: email.toLowerCase(), resident_phone: roomPh, area_id: parseInt(editLocationId),
                        resident_group_ids: resGroupIdList2, campus_id: campusId, ehr_external_id: ehrid,
                        resident_nickname: nName, offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                        offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}];
                oldPayload = [{resident_id: parseInt(resId), resident_first_name: fnameOld, resident_last_name: lnameOld,
                               is_active: oldActive, resident_email: emailOld, resident_phone: roomPhOld,
                               area_id: locIdOld, resident_group_ids: oldResGroupIdList2, campus_id: oldCampus,
                               ehr_external_id: oldEhrId, resident_nickname: oldNickname}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_edit", Payload: payload,
                                    OldPayload: oldPayload,
                                    CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                    if (data && data[0]){
                        setResIdList([]);

                        formSuccess(`${fname} ${lname} updated.`, "editResSubmit",
                            "loadEditResSubmit", "cancelEditResBtn");
                        setRead(false);
                        setCount(0);
                    }
                    else{
                        formFail("Error during save, error code: " + data[1], "editResForm", "loadEditResSubmit");
                    }
                });
            }else{
                toast.info("No change");
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function passSubmit(){
        let password, username, msg, payload;
        if (editRights){
            handleSubmitActions("passSubmit", "loadPassSubmit");
            username = resActive[storedIndex]?.username;
            password = document.getElementById("passwordR").value;
            payload = [{Action: "reset", CampusId: campusId, Username: username, UserPass: password, RegisterType: "resident"}];
            ApiRequester({reqEndpoint: "user-manage", Payload: payload}).then(data => {
                if (data[0] === true){
                    setResIdList([]);
                    formSuccess("Password reset successfully.", "passSubmit", "loadPassSubmit", "cancelPassBtn", "passForm");
                    setCount(0);
                }
                else{
                    if (data[1] === "3"){
                        msg = "Current password does not match records.";
                    }
                    else if (data[1] === "4"){
                        msg = "User not authorized.";
                    }
                    else if (data[1] === "5"){
                        msg = "Error encountered authenticating user. Please contact support for assistance if error persists.";
                    }
                    else if (data[1] === "6"){
                        msg = "New password failed to be set, check password and try again. Contact support if failure persists.";
                    }
                    else{
                        msg = "Unknown failure, request not processed.";
                    }
                    formFail(msg, "passSubmit", "loadPassSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deleteResPerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({resident_id: dContent[i][0],
                              offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                              offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_disable", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    formSuccess("Resident moved out.", submitBtn, loadBtn, closeId);
                    setRead(false);
                    setCount(0);
                    setResIdList([]);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteResBtn", "trueDeleteBtn"]);
                }
                else{
                    formFail(`Error performing move out, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddGroupSubmit(){
        // User add form submit function
        let groupname, payload, description, categoryId;
        if (addRights){
            handleSubmitActions("addGroupSubmit", "loadAddGroupSubmit");
            groupname = document.getElementById("groupname").value;
            description = document.getElementById("description").value;
            categoryId = document.getElementById("category").value;
            payload = [{campus_id: campusId, resident_group_name: groupname, resident_description: description,
                        resident_ids: resIdList2, resident_group_category_id: parseInt(categoryId)}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_group_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setResGroupIdList([]);
                    formSuccess("Group has been added.", "addGroupSubmit", "loadAddGroupSubmit", "cancelAddGroupBtn", "addGroupForm");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addGroupSubmit", "loadAddGroupSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditGroupSubmit(){
        // User add form submit function
        let groupId, groupname, description, payload, categoryId, oldCategoryId, oldDescription, oldGroupName,
            oldPayload;
        if (editRights){
            groupId = document.getElementById("groupIdE").value;
            groupname = document.getElementById("groupNameE").value;
            description = document.getElementById("descriptionE").value;
            categoryId = document.getElementById("categoryE").value;
            oldGroupName = groupActive[storedIndex]?.resident_group_name;
            oldCategoryId = groupActive[storedIndex]?.resident_group_category_id;
            oldDescription = groupActive[storedIndex]?.resident_description;
            if (arrayComparison([groupname, description, categoryId], [oldGroupName, oldDescription, oldCategoryId])
                || arrayComparison(resIdList2, oldResIdList2)){
                handleSubmitActions("editGroupSubmit", "loadEditGroupSubmit");
                payload = [{resident_group_name: groupname, resident_group_id: parseInt(groupId), resident_group_category_id: parseInt(categoryId),
                        resident_description: description, resident_ids: resIdList2, campus_id: dData.acnt}];
                oldPayload = [{resident_group_name: oldGroupName, resident_group_id: parseInt(groupId),
                               resident_group_category_id: oldCategoryId, resident_description: oldDescription,
                               resident_ids: oldResIdList2, campus_id: dData.acnt}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_group_edit", Payload: payload,
                                    CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                    ClientId: dData.sessionId}).then(data => {
                    if (data[0]){
                        setRead(false);
                        setCount(0);
                        setResGroupIdList([]);
                        formSuccess("Group updated.", "editGroupSubmit", "loadEditGroupSubmit", "cancelEditGroupBtn");
                    }
                    else{
                        formFail(`Error during save, error code: ${data[1]}`, "editGroupSubmit", "loadEditGroupSubmit");
                    }
                });
            }else{
                toast.info("No data changed.");
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deleteGroupPerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent?.length; i++){
                payload.push({resident_group_id: parseInt(dContent[i][0])});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_group_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    formSuccess("Groups have been deleted.", submitBtn, loadBtn, closeId);
                    setCount(0);
                    setResGroupIdList([]);
                    document.getElementById("uCheckHead4").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteGroupBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deviceExists(serialNum){
        for (let i=0; i < deviceData.length; i++){
            if (serialNum.toString() === deviceData[i]?.manufacture_uuid.toString()) {
                return deviceData[i];
            }
        }
        return false;
    }

    function getModelId(){
        let models = [], ret = 0;
        for (let i=0; i < deviceTypeData.length; i++){
            if (deviceTypeData[i]?.inovonics_type_id === deviceTypeId){
                models = deviceTypeData[i]?.models ? deviceTypeData[i].models : [];
                break;
            }
        }
        for (let i2=0; i2 < models.length; i2++){
            if (listenPCode === models[i2].product_type_id){
                ret = models[i2].model_id;
            }
        }
        return ret;
    }

    function pendantSubmit(initial){
        let description, msg, payload, serialNum, fname, lname, resId, dRec, mId, oldPayload;
        if (devEditRights){
            if (showDeviceList){
                serialNum = listenDevice;
            }else{
                if (!serialNum || serialNum === ""){
                    serialNum = document.getElementById("serialNum").value;
                }
                if (serialNum && !isNaN(serialNum)){
                    serialNum = parseInt(serialNum);
                }
            }
            if (manufactureId.toString() === "4" && deviceTypeId.toString() === "1"){
                serialNum = serialNum.toString()
            }
            dRec = deviceExists(serialNum);
            if (initial){
                if (dRec && dRec?.is_active){
                    setAssignedRes(dRec?.resident_name);
                    hideModal("pendantmodal");
                    showModal("pendantconfirmmodal");
                    return
                }else{
                    handleSubmitActions("pendantSubmit", "loadPendantSubmit");
                }
            } else{
                handleSubmitActions("pendantConfirmSubmit", "loadPendantConfirmSubmit");
            }

            if (listening){
                setListening(false);
                setListenCount(60);
            }

            fname = document.getElementById("fNameE").value;
            lname = document.getElementById("lNameE").value;
            resId = document.getElementById("resUnqIdE").value;
            description = document.getElementById("description").value;
            mId = modelId;
            if (!iAmHigherAuthority(80, dData.role_weight) && showDeviceList){
                mId = getModelId(listenPCode);
            }

            if (dRec){
                // Edit device and add to resident
                payload = [{device_id: dRec.device_id, campus_id: campusId, is_active: true, resident_id: parseInt(resId),
                            device_name: deviceTypeName, manufacture_model_id: parseInt(mId), device_use_id: parseInt(useId),
                            descriptions: description, is_resident: true, is_area_device: false, area_id: 0,
                            device_type_id: deviceTypeId, modified_by: dData.user,
                            offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                            offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}];
                oldPayload = [{device_id: dRec.device_id, campus_id: dRec?.campus_id, is_active: dRec?.is_active,
                               resident_id: dRec?.resident_id, device_name: dRec?.device_name,
                               manufacture_model_id: dRec?.manufacture_model_id, device_use_id: dRec?.device_use_id,
                               descriptions: dRec?.descriptions, is_resident: dRec?.is_resident,
                               is_area_device: dRec?.is_area_device, area_id: dRec?.area_id,
                               device_type_id: dRec?.device_type_id}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "device_assign_resident", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                    if (data && data[0] === true){
                        msg = `${deviceTypeName} has been added to ${fname} ${lname}`;
                        if (!initial){
                            handleSubmitActions("loadPendantConfirmSubmit", "pendantConfirmSubmit");
                            handleSubmitActions("loadPendantSubmit", "pendantSubmit");
                            swapModal("pendantConfirmClose", "editmodal");
                            document.getElementById("pendantForm").reset();
                            toast.success(msg);
                            setRead(false);
                            setCount(0);
                            setShowDeviceList(false);
                        }else{
                            formSuccess(msg, "pendantSubmit", "loadPendantSubmit", "cancelPendantBtn", "pendantForm");
                            setCount(0);
                        }
                    }
                    else{
                        handleSubmitActions("loadPendantConfirmSubmit", "pendantConfirmSubmit");
                        toast.error(`Failed to add ${deviceTypeName}`);
                    }
                });
            }else{
                // Add device and add to resident
                payload = [{campus_id: campusId, manufacture_id: parseInt(manufactureId), manufacture_uuid: serialNum.toString(),
                            device_name: deviceTypeName, device_use_id: parseInt(useId), is_active: true, is_alerting_now: false, is_server: false,
                            is_area_device: false, is_resident: true, resident_id: parseInt(resId), manufacture_model_id: parseInt(mId),
                            escalation_enabled: true, careflow_id: 1, descriptions: description,
                            modified_by: dData.user, device_type_id: deviceTypeId,
                            offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                            offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "device_add_resident", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: [],
                                ClientId: dData.sessionId}).then(data => {
                    if (data && data[0] === true){
                        msg = `${deviceTypeName} has been added to ${fname} ${lname}`;
                        formSuccess(msg, "pendantSubmit", "loadPendantSubmit", "cancelPendantBtn", "pendantForm");
                        setRead(false);
                        setCount(0);
                        setShowDeviceList(false);
                    }
                    else{
                        toast.error(`Failed to add ${deviceTypeName}`);
                        handleSubmitActions("loadPendantSubmit", "pendantSubmit");
                    }
                });
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function publishListen(){
        let sendPtype, modelStuff;
        if (dData.serverVersion === "" || versionSort(dData.serverVersion, "4.04.14") >= 0){
            sendPtype = iAmHigherAuthority(80, dData.role_weight) ? [productCode] : allProductCodes;
            modelStuff = iAmHigherAuthority(80, dData.role_weight) ? `Specific ${productCode}` : "All codes";
        }else{
            sendPtype = productCode;
            modelStuff = productCode;
        }
        ApiRequester({reqEndpoint: "mqtt", Operation: "learnin", ClientId: dData.sessionId,
                            ProductType: sendPtype, CampusId: dData?.acnt, MsgClass: msgClass}).then(data => {

            if (data[0]){
                toast.info(`Listening for ${deviceTypeName} devices, Model Code: ${modelStuff}`);
                setListenCount(0);
            }
            else{
                toast.error("Error with auto listening, try again, " +
                    "if persist contact your customer success for assistance.");
                setListening(false);
                setShowDeviceList(false);
            }
        });
    }

    function trueDeleteSubmit(start, end, resList){
        let payload;
        if (iAmHigherAuthority(99, dData.role_weight)){
            payload = [];
            handleSubmitActions("trueDeleteConfirmSubmit", "loadTrueDeleteConfirmSubmit");
            for (let i=0; i < resList.length; i++){
                payload.push({resident_id: parseInt(resList[i])});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId,
                                offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                                offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}).then(data => {
                if (data[0]){
                    formSuccess("Resident moved out.", "trueDeleteConfirmSubmit", "loadTrueDeleteConfirmSubmit", "trueDeleteConfirmClose");
                    setRead(false);
                    setCount(0);
                    setResIdList([]);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteResBtn", "trueDeleteBtn"]);
                }
                else{
                    formFail(`Error performing move out, error code: ${data[1]}`, "trueDeleteConfirmSubmit", "loadTrueDeleteConfirmSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    // Main Residents Table Header
    const resTableHead = <TableHeaders checkbox={deleteRights} headerData={resHeaderData} checkAll={() => checkAll(ppRules.start, ppRules.end, resIdList, setResIdList, "uCheckHead", "uCheckRes")}
                                                   writeAccess={editRights || groupEditRights} sortOrder={sorter.sortOrder} modal_name={"Edit"} originData={resTransOrigin} headerFiltersOn={true}
                                                   sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} modal={editRights || groupEditRights} checkboxlist={resIdList}
                                                   actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn", "trueDeleteBtn"], "uCheckRes")} checkboxHeaderId={"uCheckHead"}
                                                   headerFilters={resHeaderFilters} setHeaderFilters={setResHeaderFilters} setPage={setPage}/>
    // Group Add Resident Table Header
    const resTableHead2 = <TableHeaders checkbox={deleteRights} headerData={resHeaderData2} checkAll={() => checkAll(0, resDataCnt, resIdList2, setResIdList2, "uCheckHead2", "uCheckRes2_")}
                                                   writeAccess={editRights || groupEditRights} sortOrder={sorter.sortOrder} originData={resTransOrigin} headerFiltersOn={false}
                                                   sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={resIdList2}
                                                   actionAppearance={() => {}} checkboxHeaderId={"uCheckHead2"} />
    // Group Edit Resident Table Header
    const resTableHead3 = <TableHeaders checkbox={deleteRights} headerData={resHeaderData2} checkAll={() => checkAll(0, resDataCnt, resIdList2, setResIdList2, "uCheckHead3", "uCheckRes2_")}
                                                   writeAccess={editRights || groupEditRights} sortOrder={sorter.sortOrder} originData={resTransOrigin} headerFiltersOn={false}
                                                   sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={resIdList2}
                                                   actionAppearance={() => {}} checkboxHeaderId={"uCheckHead3"} />

    // Main Group Table Head
    const groupTableHead = <TableHeaders checkbox={groupEditRights} headerData={groupHeaderData} checkboxlist={resGroupIdList}
                                         checkAll={() => checkAll(ppRules2.start, groupDataCnt ? groupDataCnt : 0, resGroupIdList, setResGroupIdList, "uCheckHead4", "uCheckGroup")}
                                         writeAccess={groupEditRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead4"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2} modal={groupEditRights} modal_name={"Edit"}
                                         actionAppearance={() => actionAppearance(ppRules2.start, ppRules2.end, ["deleteGroupBtn"], "uCheckGroup")}
                                         headerFilters={groupHeaderFilters} setHeaderFilters={setGroupHeaderFilters} setPage={setPage2} />
    // Resident Add Group Table Head
    const groupTableHead2 = <TableHeaders checkbox={true} headerData={groupHeaderData2} checkboxlist={resGroupIdList2}
                                         checkAll={() => checkAll(0, groupDataCnt ? groupDataCnt : 0, resGroupIdList2, setResGroupIdList2, "uCheckHead5", "uCheckGroup2_")}
                                         writeAccess={addRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead5"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                         actionAppearance={() => {}} />
    // Resident Edit Group Table Head
    const groupTableHead3 = <TableHeaders checkbox={true} headerData={groupHeaderData2} checkboxlist={resGroupIdList2}
                                         checkAll={() => checkAll(0, groupDataCnt ? groupDataCnt : 0, resGroupIdList2, setResGroupIdList2, "uCheckHead6", "uCheckGroup2_")}
                                         writeAccess={addRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead6"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                         actionAppearance={() => {}} />

    const assignedHeaders = <TableHeaders checkbox={true} headerData={deviceHeaders} checkAll={() => {}}
                                       writeAccess={true} sortOrder={assignedSorter.sortOrder} originData={assignedDevices} headerFiltersOn={true}
                                       sortColumn={assignedSorter.sortColumn} sorter={assignedSorter} setSorter={setAssignedSorter} checkboxlist={[]}
                                       actionAppearance={() => {}} headerFilters={assignedFilters} setHeaderFilters={setAssignedFilters} />

    const unassignedHeaders = <TableHeaders checkbox={true} headerData={deviceHeaders} checkAll={() => {}}
                                       writeAccess={true} sortOrder={unassignedSorter.sortOrder} originData={unassignedDevices} headerFiltersOn={true}
                                       sortColumn={unassignedSorter.sortColumn} sorter={setUnassignedSorter} setSorter={setAssignedSorter} checkboxlist={[]}
                                       actionAppearance={() => {}} headerFilters={unassignedFilters} setHeaderFilters={setUnassignedFilters} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                <div className={"d-block"}>
                    {deleteRights
                        ?   <>
                                <Button text={"Move Out"} type={"button"} iconClass={"fe fe-user-x me-2"}
                                        class={"btn btn-danger ms-2 hide mt-1"} id={"deleteResBtn"} icon={true}
                                        onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, resActive,
                                ["resident_first_name", "resident_last_name"], ["resident_id", ""],
                                            "", setDContent, "Are you sure you want to move out the following residents? \n",
                                            "bulkdeleteresmodal", "deleteResModalContent", "uCheckRes")} />
                            </>
                        :   <></>
                    }
                    {iAmHigherAuthority(99, dData.role_weight)
                        ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                id={"trueDeleteBtn"} icon={true} iconClass={"fe fe-trash me-2"}
                                onClick={() => {
                                    formCheck("trueDeleteForm", "trueDeleteConfirmSubmit");
                                    showModal("truedeletemodal");
                            }} />
                        :   <></>
                    }
                    {deleteRights
                        ?   <>
                                <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"deleteGroupBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                     onClick={() => bulkDeleteModal(ppRules2.start, ppRules2.end, groupActive,
                                         "resident_group_name", ["resident_group_id", ""], "resident_group_name",
                                         setDContent, "Are you sure you want to delete the following groups?",
                                         "bulkdeletegroupmodal", "deleteGroupModalContent", "uCheckGroup")} />
                            </>
                        :   <></>
                    }
                    <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                        <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                             onKeyUp={(e) => setSearch(e.target.value)} />
                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"} id={"search-btn-1"} />
                    </div>
                    {csvButton}
                    {addRights && tabItem === "residents"
                        ?   <Button text={"New Resident"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                 icon={true} iconClass={"fe fe-plus me-2"}
                                 onClick={() => {
                                     setSearch2("");
                                     // document.getElementById("locationId").value = "";
                                     setAddLocationId("");
                                     document.getElementById("fName").value = "";
                                     document.getElementById("lName").value = "";
                                     document.getElementById("nickname").value = "";
                                     document.getElementById("uCheckHead5").checked = false;
                                     document.getElementById("moveindate").value = formatDateIso(getToday(0));
                                     document.getElementById("moveindate").required = false;
                                     document.getElementById("moveindate").disabled = true;
                                     document.getElementById("set-move-in").checked = false;
                                     setStoredIndex(undefined);
                                     setShowChecked(false);
                                     setResGroupIdList2([]);
                                     formCheck("addResForm", "addResSubmit");
                                     showModal("addresmodal");}} />
                        :   <></>
                    }
                    {addRights && tabItem === "groups"
                        ?   <Button text={"New Group"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                     icon={true} iconClass={"fe fe-plus me-2"}
                                     onClick={() => {
                                         setResLinkClose("cancelAddResBtn");
                                         setSearch2("");
                                         setResIdList2([]);
                                         document.getElementById("uCheckHead2").checked = false;
                                         setStoredIndex(undefined);
                                         setShowChecked(false);
                                         showModal("addgroupmodal");
                                         formCheck("addGroupForm", "addGroupSubmit");}} />
                        :   <></>
                    }
                </div>
                <div className={"d-block"}>
                    <div className={"form-check d-inline-block mt-3 float-end"}>
                        <input className={"form-check-input form-check-med"} id={"active-toggle"} name={"active-toggle"}
                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                               type={"checkbox"} checked={showInactive} onChange={(e) => {
                                   setShowInactive(e.target.checked);
                        }} />
                        <label className={"form-check-label"} htmlFor={"active-toggle"}>Show moved out</label>
                    </div>
                </div>
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={(e) => {
                                setResOrigin([]);
                                setGroupOrigin([]);
                                setResDataLoaded(false);
                                setResLoaded(false);
                                setDeviceDataLoaded(false);
                                setDevicesLoaded(false);
                                setAreaLoaded(false);
                                setGroupDataLoaded(false);
                                setCatLoaded(false);
                                setGroupsLoaded(false)
                                setAddRights((!dData.campusData[dData.acnt.toString()]?.ehr_active && iAmHigherAuthority(10, dData.role_weight)) || iAmHigherAuthority(80, dData.role_weight));
                                setEditRights((!dData.campusData[dData.acnt.toString()]?.ehr_active && iAmHigherAuthority(10, dData.role_weight)) || iAmHigherAuthority(80, dData.role_weight));
                                setDeleteRights((!dData.campusData[dData.acnt.toString()]?.ehr_active && iAmHigherAuthority(10, dData.role_weight)) || iAmHigherAuthority(80, dData.role_weight));
            }}/>
        </div>
    );

    const footer = (<>
        {tabItem === "residents"
            ?   <div className={"d-flex align-items-center"}>
                    <Pagination className={"mb-0"}>
                        <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                         endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                         max={ppRules.max}/>
                    </Pagination>
                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
                </div>
            :   <div className={"d-flex align-items-center"}>
                    <Pagination className={"mb-0"}>
                        <PaginationItems setPage={setPage2} page={page2} beginDot={ppRules2.beginDot}
                                         endDot={ppRules2.endDot} pageMin={ppRules2.pageMin} pageMax={ppRules2.pageMax}
                                         max={ppRules2.max}/>
                    </Pagination>
                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
                </div>
        }
    </>);

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Community"} Title={"Residents"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                        <li className={"nav-item"}>
                             <Button text={"Residents"}  spinner={!resLoaded}
                                     class={tabItem === "residents" ? "nav-link active" : "nav-link"}
                                     onClick={() => setTabItem("residents")}/>
                        </li>
                        <li className={"nav-item"}>
                            <Button text={"Resident Groups"}  spinner={!groupsLoaded}
                                     class={tabItem === "groups" ? "nav-link active" : "nav-link"}
                                     onClick={() => setTabItem("groups")}/>
                        </li>
                    </ul>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <TableSkeleton />
                    </div>
                    <div className={tabItem === "residents" ? "d-block" : "d-none"}>
                        <div className={"d-flex justify-content-end mb-2"}>
                            <span className={"text-muted"} style={{fontSize: "var(--font-size-sm)"}}>
                                Showing <strong>{Math.min(ppRules.start+1, resTransOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, resTransOrigin.length)}</strong> of <strong>{resTransOrigin.length}</strong> {resTransOrigin.length === 1 ? "resident" : "residents"}
                            </span>
                        </div>
                        <table className={"table table-sm table-white table-hover"}>
                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                            {resTableHead}
                            </thead>
                            <tbody id={"tBody"}>
                            {resTableRows}
                            </tbody>
                        </table>
                    </div>
                    <div className={tabItem === "groups" ? "d-block" : "d-none"}>
                        <div className={"d-flex justify-content-end mb-2"}>
                            <span className={"text-muted"} style={{fontSize: "var(--font-size-sm)"}}>
                                Showing <strong>{Math.min(ppRules2.start+1, groupOrigin.length)}</strong> - <strong>{Math.min(ppRules2.end+1, groupOrigin.length)}</strong> of <strong>{groupOrigin.length}</strong> {groupOrigin.length === 1 ? "group" : "groups"}
                            </span>
                        </div>
                        <table className={"table table-sm table-white table-hover"}>
                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                            {groupTableHead}
                            </thead>
                            <tbody id={"tBody"}>
                            {groupTableRows}
                            </tbody>
                        </table>
                    </div>
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade"} id={"addresmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Resident</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"addResForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"mb-3"}>
                                    <SearchableDropdown
                                        dataset={{data: areaData, label: "area_name", value: "area_id"}}
                                        label_name={"Area"}
                                        onChange={(e) => {
                                            setAddLocationId(e)
                                        }}
                                        height={"55px"}
                                        occupancyCheck={true}
                                        value={addLocationId}
                                        clearable={true}
                                        required={true}
                                        id={"locationId"}
                                    />
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"fName"}
                                               onKeyUp={() => formCheck("addResForm", "addResSubmit")}
                                               required={true} pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                        <label className={"ms-3"} htmlFor={"fName"}>First Name</label>
                                        <div className={"invalid-feedback"}>
                                            Please enter a first name
                                        </div>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"lName"}
                                               onKeyUp={() => formCheck("addResForm", "addResSubmit")}
                                               required={true} pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                        <label className={"ms-3"} htmlFor={"lName"}>Last Name</label>
                                        <div className={"invalid-feedback"}>
                                            Please enter a last name
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"nickname"}
                                               onKeyUp={() => formCheck("addResForm", "addResSubmit")}
                                               required={false} pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                        <label className={"ms-3"} htmlFor={"nickname"}>Nickname</label>
                                        <div className={"invalid-feedback"}>
                                            Invalid value
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"roomPh"}
                                               pattern={"[0-9]{3}-?[0-9]{3}-?[0-9]{4}"}
                                               onKeyUp={() => formCheck("addResForm", "addResSubmit")}/>
                                        <label className={"ms-3"} htmlFor={"roomPh"}>Room Phone #</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid phone number xxx-xxx-xxxx
                                        </div>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"email"}
                                               onKeyUp={() => formCheck("addResForm", "addResSubmit")}
                                               pattern={"[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$"}/>
                                        <label className={"ms-3"} htmlFor={"email"}>Email Address</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid email address
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-check form-switch ms-3 mt-1 mb-2"}
                                         id={`set-move-in-div`}>
                                        <input className={"form-check-input"} id={`set-move-in`} type={"checkbox"}
                                               name={"moveindefault"} defaultChecked={false}
                                               onChange={(e) => {
                                                   document.getElementById("moveindate").disabled = !e.target.checked
                                                   document.getElementById("moveindate").required = e.target.checked;
                                                   formCheck("addResForm", "addResSubmit");
                                               }}/>
                                        <label className={"form-check-label mt-1 text-dark"}
                                               htmlFor={`set-move-in`} id={`set-move-in-label`}>
                                            Set Future Move In Date
                                        </label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"date"} className={"form-control"} id={"moveindate"}
                                               min={formatDateIso(getToday(1))}
                                               onChange={() => formCheck("addResForm", "addResSubmit")}/>
                                        <label className={"ms-3"} htmlFor={"moveindate"}>Move in Date</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid date in future
                                        </div>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"ehrid"}
                                               onKeyUp={() => formCheck("addResForm", "addResSubmit")}
                                               required={false} pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                        <label className={"ms-3"} htmlFor={"ehrid"}>EHR ID</label>
                                    </div>
                                </div>
                                <hr/>
                                <div className={"mt-1"}>
                                    <h3>Groups</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)}/>
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}
                                                id={"search-btn-2"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"resgroup-add-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"resgroup-add-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                            {groupTableHead2}
                                            </thead>
                                            <tbody>
                                            {groupTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddResBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadAddResSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"} onClick={() => formAddResSubmit()}
                                        id={"addResSubmit"}>Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editresmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}
                 style={{overflowY: "auto"}}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>Edit Resident</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"editResForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                {dData.campusData[dData.acnt.toString()]?.ehr_active
                                    ?   <h3 className={"text-danger text-center mb-4"}>
                                            Resident changes must be done in your {dData.campusData[dData.acnt.toString()].ehr_vendor_name} system
                                        </h3>
                                    :   <></>
                                }
                                <div className={"w-50 d-inline-block"}>
                                    <input type={"hidden"} id={"resUnqIdE"}/>
                                    <input type={"hidden"} id={"campusIdE"}/>
                                    {!editRights
                                        ? <div className={"form-floating mb-3"}>
                                            <input type={"hidden"} id={"origLocationIdE"}/>
                                            <input type={"hidden"} id={"locationIdE"}/>
                                            <input type={"text"} className={"form-control"} id={"locationNameE"}
                                                   readOnly={true} value={editLocationName}
                                                   onKeyUp={() => formCheck("editResForm", "editResSubmit")}
                                                   required={false}/>
                                            <label htmlFor={"locationNameE"}>Area</label>
                                        </div>
                                        :
                                        <div className={"mb-3 mt-3"}>
                                            <input type={"hidden"} id={"origLocationIdE"}/>
                                            <SearchableDropdown
                                                dataset={{data: areaData, label: "area_name", value: "area_id"}}
                                                label_name={"Area"}
                                                formCheck={() => {formCheck("editResForm", "editResSubmit")}}
                                                onChange={(e) => {
                                                    setEditLocationId(e);
                                                }}
                                                height={"55px"}
                                                occupancyCheck={true}
                                                value={editLocationId}
                                                clearable={true}
                                                required={true}
                                                id={"locationIdE"}
                                            />
                                        </div>

                                    }
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"fNameE"}
                                               readOnly={!editRights}
                                               onKeyUp={() => formCheck("editResForm", "editResSubmit")} required={true}
                                               pattern={"[0-9a-zA-Z_\\- ']+"}/>
                                        <label htmlFor={"fNameE"}>First Name</label>
                                        <div className={"invalid-feedback"}>
                                            Please enter a first name
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"lNameE"}
                                               readOnly={!editRights}
                                               onKeyUp={() => formCheck("editResForm", "editResSubmit")}
                                               required={true}
                                               pattern={"[0-9a-zA-Z_\\- ']+"}/>
                                        <label htmlFor={"lNameE"}>Last Name</label>
                                        <div className={"invalid-feedback"}>
                                            Please enter a last name
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"nicknameE"}
                                               readOnly={!editRights}
                                               onKeyUp={() => formCheck("editResForm", "editResSubmit")}
                                               required={false}
                                               pattern={"[0-9a-zA-Z_\\- ']+"}/>
                                        <label htmlFor={"nicknameE"}>Nickname</label>
                                        <div className={"invalid-feedback"}>
                                            Invalid value
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"roomPhE"}
                                               pattern={"[0-9]{3}-?[0-9]{3}-?[0-9]{4}"} readOnly={!editRights}
                                               onKeyUp={() => formCheck("editResForm", "editResSubmit")}/>
                                        <label htmlFor={"roomPhE"}>Room Phone #</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid phone number xxx-xxx-xxxx
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"emailE"}
                                               pattern={"[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$"}
                                               readOnly={!editRights}
                                               onKeyUp={() => formCheck("editResForm", "editResSubmit")}/>
                                        <label htmlFor={"emailE"}>Email</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid email address
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"ehridE"}
                                               readOnly={!editRights}
                                               onKeyUp={() => formCheck("editResForm", "editResSubmit")}/>
                                        <label htmlFor={"ehridE"}>EHR ID</label>
                                    </div>
                                </div>
                                <div className={"w-50 d-inline-block align-top"} style={{paddingLeft: ".5em"}}>
                                    <div className={"modal-header px-1 pt-0"}>
                                        <h2 className={"d-inline my-0 ms-2"}>Devices</h2>
                                        {devEditRights && devicesLoaded
                                            ? <Button text={"Device"} type={"button"} class={"btn btn-primary ms-3"}
                                                      id={"pendantBtn"} icon={true} iconClass={"fe fe-plus me-2"}
                                                      onClick={() => {
                                                          setManufactureId(0);
                                                            setDeviceTypeId(0);
                                                            setDeviceCatId(0);
                                                            setListening(false);
                                                            setListenDevice("");
                                                            setListenData([]);
                                                            setListenList([]);
                                                            setShowDeviceList(false);
                                                            document.getElementById("listen-container")?.classList?.remove("d-none");
                                                            //swapModal("cancelEditBtn", "devicemodal-1")
                                                          swapModal("cancelEditResBtn", "pendantmodal");
                                                }}/>
                                            :   <></>
                                        }
                                    </div>
                                    <div className={"modal-body px-1"}>
                                        <table>
                                            <tbody>
                                            {editDeviceList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/*{isMobileActive*/}
                                {/*    ? <>*/}
                                {/*        <hr/>*/}
                                {/*        <div>*/}
                                {/*            <div>*/}
                                {/*                <h2>Mobile App</h2>*/}
                                {/*            </div>*/}
                                {/*            <div>*/}
                                {/*                {mobileAppDisplay}*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*    </>*/}
                                {/*    : <></>}*/}
                                <hr/>
                                <div className={"mt-1"}>
                                    <h3>Groups</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2E"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)}/>
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}
                                                id={"search-btn-3"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"resgroup-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"resgroup-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                            {groupTableHead3}
                                            </thead>
                                            <tbody>
                                            {groupTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    {deleteRights
                                        ?   <Button text={"Move Out"} type={"button"} class={"btn btn-danger me-3"}
                                                    id={"deleteSingleResBtn"} icon={true} iconClass={"fe fe-user-x me-2"} />
                                        :   <></>
                                    }
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditResBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadEditResSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"}
                                            onClick={() => formEditResSubmit()} id={"editResSubmit"}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addgroupmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Group</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"addGroupForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"category"} required={true}>
                                        <option value={""}></option>
                                        {groupCatDd}
                                    </select>
                                    <label htmlFor={"category"}>Group Category</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"groupname"}
                                           onKeyUp={() => formCheck("addGroupForm", "addGroupSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"groupname"}>Group Name</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a valid group name.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"description"}
                                           onKeyUp={() => formCheck("addGroupForm", "addGroupSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <label htmlFor={"description"}>Description</label>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Residents</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"res-add-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"res-add-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {resTableHead2}
                                            </thead>
                                            <tbody>
                                                {resTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddGroupBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadAddGroupSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"}
                                        onClick={() => formAddGroupSubmit()} id={"addGroupSubmit"}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editgroupmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Group</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"editGroupForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <input type={"hidden"} id={"groupIdE"} />
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"categoryE"} required={true}
                                            onChange={() => formCheck("editGroupForm", "editGroupSubmit")}>
                                        <option value={""}></option>
                                        {groupCatDd}
                                    </select>
                                    <label htmlFor={"categoryE"}>Group Category</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"groupNameE"}
                                           onKeyUp={() => formCheck("editGroupForm", "editGroupSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"groupNameE"}>Group Name</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a group name!
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"descriptionE"}
                                           onKeyUp={() => formCheck("editGroupForm", "editGroupSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <label htmlFor={"descriptionE"}>Description</label>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Residents</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2E"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"res-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"res-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {resTableHead3}
                                            </thead>
                                            <tbody>
                                                {resTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    {deleteRights
                                        ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger me-3"}
                                                     id={"deleteSingleGroupBtn"} icon={true}
                                                     iconClass={"fe fe-trash-2 me-2"}/>
                                        :   <></>
                                    }
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditGroupBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadEditGroupSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => formEditGroupSubmit()} id={"editGroupSubmit"}>Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"devicemodal-1"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticDeviceBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticDeviceBackdropLabel"}>Select device to add</h2>
                            <button type={"button"} className={"btn-close"} id={"devicemodal-1Close"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <ul className={"nav nav-tabs nav-overflow header-tabs"} style={{display: "flex", borderBottom: "2px solid var(--color-border)"}}>
                            <li key={"set-assign"} className={"nav-item"} style={{flex: "1", textAlign: "center"}}>
                                <Button text={"Assign Device"}
                                        class={deviceTabItem === "assign" ? "nav-link active" : "nav-link"}
                                        style={{
                                            width: "100%",
                                            borderRadius: "0",
                                            border: "none",
                                            borderBottom: deviceTabItem === "assign" ? "3px solid var(--color-primary)" : "3px solid transparent",
                                            backgroundColor: deviceTabItem === "assign" ? "transparent" : "transparent",
                                            color: deviceTabItem === "assign" ? "var(--color-primary)" : "var(--color-text-secondary)",
                                            fontWeight: deviceTabItem === "assign" ? "600" : "400",
                                            transition: "all 0.2s ease-in-out",
                                            padding: "0.75rem 1rem",
                                            marginBottom: "-2px"
                                        }}
                                        onClick={() => {
                                            setDeviceTabItem("assign");
                                            setAssignTabItem("assigned");
                                        }}/>
                            </li>
                            <li key={"set-register"} className={"nav-item"} style={{flex: "1", textAlign: "center"}}>
                                <Button text={"Register New Device"}
                                        class={deviceTabItem === "register" ? "nav-link active" : "nav-link"}
                                        style={{
                                            width: "100%",
                                            borderRadius: "0",
                                            border: "none",
                                            borderBottom: deviceTabItem === "register" ? "3px solid var(--color-primary)" : "3px solid transparent",
                                            backgroundColor: deviceTabItem === "register" ? "transparent" : "transparent",
                                            color: deviceTabItem === "register" ? "var(--color-primary)" : "var(--color-text-secondary)",
                                            fontWeight: deviceTabItem === "register" ? "600" : "400",
                                            transition: "all 0.2s ease-in-out",
                                            padding: "0.75rem 1rem",
                                            marginBottom: "-2px"
                                        }}
                                        onClick={() => setDeviceTabItem("register")}/>
                            </li>
                        </ul>
                        <div className={"modal-body"}>
                            <div className={deviceTabItem === "assign" ? "d-block" : "d-none"}>
                                <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                    <li key={"set-basic"} className={"nav-item"}>
                                        <Button text={"Unassigned Devices"}
                                                class={assignTabItem === "basic" ? "nav-link active" : "nav-link"}
                                                onClick={() => setAssignTabItem("assigned")}/>
                                    </li>
                                    <li key={"set-settings"} className={"nav-item"}>
                                        <Button text={"Assigned Devices"}
                                                class={assignTabItem === "settings" ? "nav-link active" : "nav-link"}
                                                onClick={() => setAssignTabItem("unassigned")}/>
                                    </li>
                                </ul>
                                <div className={assignTabItem === "assigned" ? "d-block" : "d-none"}>
                                    <table className={"table table-sm table-white table-hover"}>
                                        <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                        {assignedHeaders}
                                        </thead>
                                        <tbody id={"tBody"}>
                                        {assignedTableRows}
                                        </tbody>
                                    </table>
                                </div>
                                <div className={assignTabItem === "unassigned" ? "d-block" : "d-none"}>
                                    <table className={"table table-sm table-white table-hover"}>
                                        <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                        {unassignedHeaders}
                                        </thead>
                                        <tbody id={"tBody"}>
                                        {unassignedTableRows}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={deviceTabItem === "register" ? "d-block" : "d-none"}>
                                {iAmHigherAuthority(80, dData?.role_weight)
                                    ? <div style={{textAlign: "right"}}>
                                        <button type={"button"} className={"btn btn-link p-0 mb-3"} id={"advanced-reg"}
                                                style={{color: "var(--color-primary)", textDecoration: "none", border: "none",
                                                    backgroundColor: "transparent", padding: "0.5rem 0",
                                                    transition: "all 0.2s ease-in-out", fontSize: "0.875rem"}}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.textDecoration = "underline";
                                                    e.currentTarget.style.color = "#0056b3";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.textDecoration = "none";
                                                    e.currentTarget.style.color = "#007bff";
                                                }}
                                                onClick={() => {
                                                    swapModal("devicemodal-1Close", "pendantmodal")
                                                }}>Advanced Register</button>
                                      </div>
                                    : <></>
                                }
                                <div className={"container-fluid p-0"} id={"register-1-a"}>
                                    <div className={"row g-3 mb-3"}>
                                        <div className={"col-4"}>
                                            <button type={"button"} className={"btn btn-link p-0 w-100"}
                                                    style={{border: "2px solid var(--color-border)", borderRadius: "8px",
                                                            overflow: "hidden", transition: "all 0.2s ease-in-out",
                                                            backgroundColor: "var(--color-bg-secondary)"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#007bff";
                                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,123,255,0.2)"}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                        e.currentTarget.style.boxShadow = "none";}}
                                                    onClick={() => {}}>
                                                <img src={`/static/image/waterproof_pendant.webp`}
                                                     alt={"Waterproof Pendant"} className={"w-100"}
                                                     style={{objectFit: "contain", height: "120px", padding: "10px"}}/>
                                                <div className={"text-center py-2"}
                                                     style={{fontSize: "0.875rem", color: "var(--color-text-primary)"}}>
                                                    Waterproof Pendant
                                                </div>
                                            </button>
                                        </div>
                                        <div className={"col-4"}>
                                            <button type={"button"} className={"btn btn-link p-0 w-100"}
                                                    style={{border: "2px solid var(--color-border)", borderRadius: "8px",
                                                        overflow: "hidden", transition: "all 0.2s ease-in-out",
                                                        backgroundColor: "var(--color-bg-secondary)"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#007bff";
                                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,123,255,0.2)";}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                        e.currentTarget.style.boxShadow = "none"}}
                                                    onClick={() => {}}>
                                                <img src={`/static/image/fall_detect_pendant.png`}
                                                     alt={"Fall Detect Pendant"} className={"w-100"}
                                                     style={{objectFit: "contain", height: "120px", padding: "10px"}}/>
                                                <div className={"text-center py-2"}
                                                     style={{fontSize: "0.875rem", color: "var(--color-text-primary)"}}>
                                                    Fall Detect Pendant
                                                </div>
                                            </button>
                                        </div>
                                        <div className={"col-4"}>
                                            <button type={"button"} className={"btn btn-link p-0 w-100"}
                                                    style={{border: "2px solid var(--color-border)", borderRadius: "8px",
                                                        overflow: "hidden", transition: "all 0.2s ease-in-out",
                                                        backgroundColor: "var(--color-bg-secondary)"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#007bff";
                                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,123,255,0.2)"}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                        e.currentTarget.style.boxShadow = "none"}}
                                                    onClick={() => {}}>
                                                <img src={`/static/image/water_resistant_pendant.png`}
                                                     alt={"Water Resistant Pendant"} className={"w-100"}
                                                     style={{objectFit: "contain", height: "120px", padding: "10px"}}/>
                                                <div className={"text-center py-2"}
                                                     style={{fontSize: "0.875rem", color: "var(--color-text-primary)"}}>
                                                    Water Resistant Pendant
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div className={"row g-3 mb-3"}>
                                        <div className={"col-4"}>
                                            <button type={"button"} className={"btn btn-link p-0 w-100"}
                                                    style={{border: "2px solid var(--color-border)", borderRadius: "8px",
                                                        overflow: "hidden", transition: "all 0.2s ease-in-out",
                                                        backgroundColor: "var(--color-bg-secondary)"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#007bff";
                                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,123,255,0.2)";}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                        e.currentTarget.style.boxShadow = "none";}}
                                                    onClick={() => {}}>
                                                <img src={`/static/image/double_button_pendant.jpg`}
                                                     alt={"Double Button Pendant"} className={"w-100"}
                                                     style={{objectFit: "contain", height: "120px", padding: "10px"}}/>
                                                <div className={"text-center py-2"}
                                                     style={{fontSize: "0.875rem", color: "var(--color-text-primary)"}}>
                                                    Double Button Pendant
                                                </div>
                                            </button>
                                        </div>
                                        <div className={"col-4"}>
                                            <button type={"button"} className={"btn btn-link p-0 w-100"}
                                                    style={{border: "2px solid var(--color-border)", borderRadius: "8px",
                                                        overflow: "hidden", transition: "all 0.2s ease-in-out",
                                                        backgroundColor: "var(--color-bg-secondary)"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#007bff";
                                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,123,255,0.2)"}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                        e.currentTarget.style.boxShadow = "none";}}
                                                    onClick={() => {}}>
                                                <img src={`/static/image/mobile_pressure_pad.webp`}
                                                     alt={"Mobile Pressure Pad"} className={"w-100"}
                                                     style={{objectFit: "contain", height: "120px", padding: "10px"}}/>
                                                <div className={"text-center py-2"}
                                                     style={{fontSize: "0.875rem", color: "var(--color-text-primary)"}}>
                                                    Mobile Pressure Pad
                                                </div>
                                            </button>
                                        </div>
                                        <div className={"col-4"}>
                                            <button type={"button"} className={"btn btn-link p-0 w-100"}
                                                    style={{border: "2px solid var(--color-border)", borderRadius: "8px",
                                                        overflow: "hidden", transition: "all 0.2s ease-in-out",
                                                        backgroundColor: "var(--color-bg-secondary)"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#007bff";
                                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,123,255,0.2)"}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#dee2e6";
                                                        e.currentTarget.style.boxShadow = "none"}}
                                                    onClick={() => {}}>
                                                <div style={{height: "120px", display: "flex", alignItems: "center",
                                                    justifyContent: "center", backgroundColor: "var(--color-bg-tertiary)", padding: "10px"}}>
                                                    <span style={{color: "var(--color-text-secondary)", fontSize: "0.875rem"}}>Placeholder</span>
                                                </div>
                                                <div className={"text-center py-2"} style={{fontSize: "0.875rem", color: "var(--color-text-primary)"}}>
                                                    Device 6
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-12"}>
                                            <button type={"button"} className={"btn btn-outline-secondary w-100"}
                                                    style={{padding: "0.75rem", borderRadius: "8px",
                                                        border: "2px solid var(--color-text-secondary)", transition: "all 0.2s ease-in-out"}}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#6c757d";
                                                        e.currentTarget.style.color = "white"}}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = "transparent";
                                                        e.currentTarget.style.color = "#6c757d"}}
                                                    onClick={() => {}}>
                                                View Additional Devices
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div id={"register-1-b"}></div>
                            </div>
                        </div>
                        <div className={"modal-footer"} style={{justifyContent: "space-between"}}>

                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"pendantmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticDeviceBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticDeviceBackdropLabel"}>Add Device</h2>
                            <button type={"button"} className={"btn-close"} id={"pendantClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}
                                    onClick={() => setListening(false)}/>
                        </div>
                        <form id={"pendantForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3 d-inline-block me-2"} style={{width: "68%"}}>
                                    <select className={"form-select"} value={undefined}
                                            required={true} id={"device_manufacture"}
                                            onChange={(e) => {
                                                setManufactureId(e.target.value);
                                                if (e.target?.value?.toString() === "6") {
                                                    setSerialPattern("^(?:[1-9]|00?[1-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-4])$");
                                                } else if (e.target?.value?.toString() === "4") {
                                                    setSerialPattern("^[A-Za-z0-9]+$");
                                                } else {
                                                    setSerialPattern("^[0-9]+$");
                                                }
                                                setDeviceCatId(0);
                                                setDeviceTypeId(0);
                                                setModelId(0);
                                                formCheck("pendantForm", "pendantSubmit");
                                            }}>
                                        <option value={""}></option>
                                        {manufactureOptions}
                                    </select>
                                    <label htmlFor={"device_manufacture"}>Device Manufacturer</label>
                                </div>
                                <div className={"form-floating mb-3 d-inline-block me-2"} style={{width: "68%"}}>
                                    <select className={"form-select"} value={undefined}
                                            required={true} id={"device_category"}
                                            onChange={(e) => {
                                                setDeviceCatId(parseInt(e.target.value));
                                                setDeviceTypeId(0);
                                                setModelId(0);
                                                formCheck("pendantForm", "pendantSubmit");
                                            }}>
                                        <option value={""}></option>
                                        {deviceCatOptions}
                                    </select>
                                    <label htmlFor={"device_category"}>Device Category</label>
                                </div>
                                <div className={"d-flex justify-content-start"}>
                                    <div className={"form-floating mb-3 d-inline-block me-2"} style={{width: "68%"}}>
                                        <select className={"form-select"} required={true}
                                                value={undefined} id={"device_type_id"}
                                                onChange={(e) => {
                                                    setDeviceTypeId(parseInt(e.target.value));
                                                    setDeviceTypeName(e.target[e.target.selectedIndex].innerText);
                                                    if (manufactureId.toString() === "6") {
                                                        if (e.target.value.toString() === "4") {
                                                            setSerialPattern("^[0-9a-zA-z]+$");
                                                            document.getElementById("serialNum").pattern = "^[0-9a-zA-z]+$";
                                                        } else {
                                                            setSerialPattern("^(?:[1-9]|00?[1-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-4])$");
                                                            document.getElementById("serialNum").pattern = "^(?:[1-9]|00?[1-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-4])$";
                                                        }
                                                    }
                                                    formCheck("pendantForm", "pendantSubmit");
                                                }}>
                                            <option value={""}></option>
                                            {deviceTypeOptions}
                                        </select>
                                        <label htmlFor={"device_type_id"}>Device Type</label>
                                        <div className={deviceImg ? "select-img-div" : "select-img-div-nohover"}>
                                            {deviceImg
                                                ?   <img src={`/static/image/${deviceImg}`}
                                                         alt={""}
                                                         className={"mx-auto"}
                                                         style={{
                                                            width: "inherit",
                                                            height: "inherit",
                                                            padding: "0 10px 6px 0"
                                                    }}/>
                                                :   <></>
                                            }
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3 d-inline-block ms-auto"} style={{width: "30%"}}>
                                        <select className={"form-select"} id={"modelId"} value={modelId}
                                                onChange={(e) => {
                                                    setModelId(parseInt(e.target.value));
                                                    formCheck("pendantForm", "pendantSubmit");
                                                }}>
                                            {modelOptions}
                                        </select>
                                        <label htmlFor={"modelId"}>Model</label>
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"description"}
                                           pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                    <label htmlFor={"description"}>Description (optional)</label>
                                </div>
                                <div className={"d-flex justify-content-start"}>
                                    <div className={`form-floating mb-3 w-75 ${showDeviceList && "d-none"}`}
                                         id={"serialToggle"}>
                                        <input type={"text"} className={"form-control"} id={"serialNum"}
                                               required={!showDeviceList}
                                               onKeyUp={(e) => formCheckWithElement("pendantForm", "pendantSubmit", e, deviceData)}
                                               pattern={serialPattern}/>
                                        <label htmlFor={"serialNum"}>Serial Number</label>
                                    </div>
                                    <div className={`form-floating mb-3 w-75 ${!showDeviceList && "d-none"}`}
                                         id={"serial2Toggle"}>
                                        <select className={"form-select"} id={"serialNum2"}
                                                required={showDeviceList}
                                                onClick={(e) => {
                                                    let tmp = e.target.value.split(",");
                                                    setListenDevice(tmp[0]);
                                                    setListenPCode(parseInt(tmp[1]));
                                                }}>
                                            {listenList}
                                        </select>
                                        <label htmlFor={"serialNum2"}>Serial Numbers</label>
                                    </div>
                                    <div className={"mt-3 mt-3 ms-3 d-none"} id={"listen-container-main"}>
                                        <Button text={"Auto Listen"} id={"listen-btn-1"}
                                                class={`btn ${listenEnabled ? "btn-primary" : "btn-danger"} m-auto ${showDeviceList && "d-none"}`}
                                                disabled={!listenEnabled} onClick={() => {
                                            setListening(true);
                                            setShowDeviceList(true);
                                            publishListen()
                                        }}/>
                                        <Button text={"Stop Listen"} id={"listen-btn-2"}
                                                class={`btn ${listening ? "btn-success" : "btn-warning"} m-auto ${!showDeviceList && "d-none"}`}
                                                disabled={!listenEnabled} onClick={() => {
                                            setListening(false);
                                            setShowDeviceList(false);
                                        }}/>
                                    </div>
                                </div>
                                <div className={`list-group-item ${!showAlarmBehaviors && 'd-none'}`}
                                     id={"behavior-heading-container"}>
                                    <h4 className={"mb-4 text-center"}>Alarm Behavior</h4>
                                    {useOptions}
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelPendantBtn"}
                                            onClick={() => {
                                                //swapModal("pendantClose", "devicemodal-1");
                                                swapModal("pendantClose", "editresmodal");
                                                formClear("pendantForm", "pendantSubmit");
                                                setListening(false);
                                            }}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadPendantSubmit"}/>
                                    <button type={"button"} className={"btn btn-danger ms-3"} id={"pendantSubmit"}
                                            onClick={() => pendantSubmit(true)}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addmobilemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticDeviceBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticDeviceBackdropLabel"}>Add Mobile Account</h2>
                            <button type={"button"} className={"btn-close"} id={"addMobileClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}
                                    onClick={() => setListening(false)}/>
                        </div>
                        <form id={"addMobileForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"username"}
                                           onKeyUp={() => formCheck("addMobileForm", "addMobileSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_@-]+$"}/>
                                    <label htmlFor={"username"}>Username</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a valid username! No spaces allowed.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"password"} className={"form-control"} id={"password"} required={true}
                                           pattern={"[ -~]{6,}$"}
                                           onKeyUp={(e) => {
                                               document.getElementById("password2").pattern = e.target.value;
                                               formCheck("addMobileForm", "addMobileSubmit");
                                           }}/>
                                    <label htmlFor={"password"}>Password</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a valid password! 6 Character minimum.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"password"} className={"form-control"} id={"password2"} required={true}
                                           onKeyUp={() => formCheck("addMobileForm", "addMobileSubmit")}/>
                                    <label htmlFor={"password2"}>Confirm Password</label>
                                    <div className={"invalid-feedback"}>
                                        Confirm password must match previous password field.
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelAddMobileBtn"}
                                            onClick={() => {
                                                swapModal("addMobileClose", "editresmodal");
                                                formClear("addMobileForm", "addMobileSubmit");
                                            }}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadAddMobileSubmit"}/>
                                    <button type={"button"} className={"btn btn-danger ms-3"} id={"addMobileSubmit"}
                                            onClick={() => formAddMobileSubmit()}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"pendantconfirmmodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticPendantConfirmLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticPendantConfirmLabel"}>Confirm Add</h2>
                            <button type={"button"} className={"btn-close"} id={"pendantConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <p>Device is already linked to {assignedRes} Do you wish to re-assign this device?</p>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}}
                                    id={"pendantCancelBtn"}
                                    onClick={() => swapModal("pendantConfirmClose", "editresmodal")}>No
                            </button>
                            <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true}
                                    text={"Loading"} id={"loadPendantConfirmSubmit"}/>
                            <button type={"button"} className={"btn btn-primary ms-3"} id={"pendantConfirmSubmit"}
                                    onClick={() => pendantSubmit(false)}>YES
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"truedeletemodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticTrueDeleteConfirmLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticTrueDeleteLabel"}>Confirm Delete</h2>
                            <button type={"button"} className={"btn-close"} id={"trueDeleteConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"trueDeleteForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <p className={"fw-bold"}>Are you sure you wish to delete the selected residents, this
                                    action cannot be undone? Enter the word Delete in the following box to confirm.</p>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"confirmtext"} required={true}
                                           onKeyUp={() => formCheck("trueDeleteForm", "trueDeleteConfirmSubmit")}
                                           pattern={"(Delete){1}"} />
                                    <label htmlFor={"confirmtext"}>Confirm Delete</label>
                                    <div className={"invalid-feedback"}>
                                        Must match 'Delete' to confirm delete process.
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}}
                                        id={"trueDeleteCancelBtn"} data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true}
                                        text={"Loading"} id={"loadTrueDeleteConfirmSubmit"}/>
                                <button type={"button"} className={"btn btn-danger ms-3"} id={"trueDeleteConfirmSubmit"}
                                        onClick={() => trueDeleteSubmit(ppRules.start, ppRules.end, resIdList)}>Delete
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"passmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Reset Password</h2>
                            <button type={"button"} className={"btn-close"} id={"passClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"passForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"passwordR"}
                                           onKeyUp={() => formCheck("passForm", "passSubmit")}
                                           required={true} pattern={"[ -~]{6,}"}/>
                                    <label htmlFor={"passwordR"}>New Password</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a valid password! 6 Character minimum.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"passwordCR"}
                                           onKeyUp={() => formCheck("passForm", "passSubmit")} required={true}
                                           pattern={"[ -~]{6,}"}/>
                                    <label htmlFor={"passwordCR"}>Confirm Password</label>
                                    <div className={"invalid-feedback"}>
                                        Password does not match.
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelPassBtn"}
                                            onClick={() => {
                                                swapModal("passClose", "editresmodal");
                                                formClear("passForm", "passSubmit");
                                            }}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadPassSubmit"}/>
                                    <button type={"button"} className={"btn btn-danger ms-3"} id={"passSubmit"}
                                            onClick={() => passSubmit()}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Residents Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The Residents page allows you to manage all residents in your community. Here are some helpful tips to get you started:
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Filtering
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Search Bar:</strong> Use the search bar to quickly find residents by name, phone, email, area, or nickname.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Column Filters:</strong> Click the filter icons in column headers to filter by specific criteria.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Show Moved Out:</strong> Toggle the "Show moved out" checkbox to include or exclude inactive residents.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-user-plus me-2 text-primary"}></i>Adding Residents
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the <strong>"New Resident"</strong> button to add a new resident.
                                    </li>
                                    <li className={"mb-2"}>
                                        Fill in required fields: First Name, Last Name, and Area.
                                    </li>
                                    <li className={"mb-2"}>
                                        Optionally set a future move-in date using the "Set Future Move In Date" checkbox.
                                    </li>
                                    <li className={"mb-2"}>
                                        Assign resident groups by checking the boxes in the Groups section.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-edit me-2 text-primary"}></i>Editing Residents
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the edit icon in any row to modify resident information.
                                    </li>
                                    <li className={"mb-2"}>
                                        Update personal details, contact information, area assignment, and groups.
                                    </li>
                                    <li className={"mb-2"}>
                                        Add or remove devices from the Devices section in the edit modal.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Note:</strong> If your campus has EHR integration active, some fields may be read-only and must be updated in your EHR system.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-smartphone me-2 text-primary"}></i>Managing Devices
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        View assigned devices in the edit modal's Devices section.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the <strong>"Device"</strong> button to add a new device to a resident.
                                    </li>
                                    <li className={"mb-2"}>
                                        Remove devices by clicking the trash icon next to the device name.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use "Auto Listen" for Inovonics devices to automatically detect new devices upon activation.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-users me-2 text-primary"}></i>Resident Groups
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Assign residents to groups for easier organization and reporting.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the search bar in the Groups section to quickly find specific groups.
                                    </li>
                                    <li className={"mb-2"}>
                                        Select multiple groups by checking the boxes next to group names.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-download me-2 text-primary"}></i>Exporting Data
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the <strong>"Export"</strong> button to download resident data as a CSV file.
                                    </li>
                                    <li className={"mb-2"}>
                                        The export includes all visible columns and respects current filters.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-user-x me-2 text-primary"}></i>Moving Out Residents
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Select one or more residents using the checkboxes.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Move Out"</strong> to mark residents as inactive (moved out).
                                    </li>
                                    <li className={"mb-2"}>
                                        Moved out residents will be removed from their room and all associated devices detached.
                                    </li>
                                    <li className={"mb-2"}>
                                        Moved out residents can be hidden or shown using the "Show moved out" toggle.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click column headers to sort the table by that column.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the pagination controls at the bottom to navigate through multiple pages.
                                    </li>
                                    <li className={"mb-2"}>
                                        Adjust the number of items per page using the page size button.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click on resident names or area names to navigate to their profile pages.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <SingleDeleteModal closeBtn={"confirmResClose"} cancelBtn={"cancelDeleteResBtn"} modal_name={"editresmodal"} loadBtn={"loadDeleteResSubmit"}
                               submitBtn={"deleteResSubmit"} modalContent={"deleteResModalContent"}
                deletePerform={() => deleteResPerform("deleteResSubmit", "loadDeleteResSubmit", "confirmResClose", ppRules.start, ppRules.end)}
                header={"Delete Resident"}/>
            <SingleDeleteModal closeBtn={"confirmGroupClose"} cancelBtn={"cancelDeleteGroupBtn"} modal_name={"editgroupmodal"} loadBtn={"loadDeleteGroupSubmit"}
                               submitBtn={"deleteGroupSubmit"} modalContent={"deleteGroupModalContent"}
                deletePerform={() => deleteGroupPerform("deleteGroupSubmit", "loadDeleteGroupSubmit", "confirmGroupClose", ppRules2.start, ppRules2.end)}
                header={"Delete Resident Group"}/>
            <BulkDeleteModal closeBtn={"bulkConfirmResClose"} cancelBtn={"bulkCancelDeleteResBtn"} loadBtn={"loadBulkDeleteResSubmit"}
                             submitBtn={"bulkDeleteResSubmit"} modalContent={"deleteResModalContent"} modalName={"bulkdeleteresmodal"}
                deletePerform={() => deleteResPerform("bulkDeleteResSubmit", "loadBulkDeleteResSubmit", "bulkConfirmResClose", ppRules.start, ppRules.end)}
                start={ppRules.start} end={ppRules.end} header={"Delete Residents"}/>
            <BulkDeleteModal closeBtn={"bulkConfirmGroupClose"} cancelBtn={"bulkCancelDeleteGroupBtn"} loadBtn={"loadBulkDeleteGroupSubmit"}
                             submitBtn={"bulkDeleteGroupSubmit"} modalContent={"deleteGroupModalContent"} modalName={"bulkdeletegroupmodal"}
                deletePerform={() => deleteGroupPerform("bulkDeleteGroupSubmit", "loadBulkDeleteGroupSubmit", "bulkConfirmGroupClose", ppRules2.start, ppRules2.end)}
                start={ppRules2.start} end={ppRules2.end} header={"Delete Resident Groups"}/>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                          setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                          setPage={(sudocode, tabItem) => {
                              console.log(tabItem)
                              if (tabItem === "residents"){
                                  setPage(sudocode);
                              }else{
                                  setPage2(sudocode)
                              }
                          }}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <input className={"d-none"} type={"hidden"} id={"lastIndex"} />
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default Residents;